/* Calculadora de cortes Toolstore: proyectos, varios materiales, retazos, plan de corte por franjas, tapacanto, herrajes,
   costo, PDF, etiquetas, Excel, DXF, generador de muebles y enlace para compartir. */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-calc-cortes]');
  if (!raiz) return;

  var CLAVE = 'toolstore-calculadora-cortes-v2';
  var CLAVE_PROYECTOS = 'toolstore-calculadora-proyectos-v1';
  var datos = {};
  try { datos = JSON.parse(raiz.querySelector('[data-calc-datos]').textContent); } catch (e) { datos = {}; }
  var tableros = datos.tableros || [{ largo: 2440, ancho: 1830 }, { largo: 2440, ancho: 1220 }];

  var $ = function (sel) { return raiz.querySelector(sel); };
  var num = function (v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? 0 : n; };
  var fmt = function (n, dec) {
    return Number(n).toLocaleString('es-CL', { minimumFractionDigits: dec || 0, maximumFractionDigits: dec || 0 });
  };
  var dinero = function (centavos) { return '$' + fmt(Math.round(centavos / 100)); };
  var pesos = function (p) { return '$' + fmt(Math.round(p)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- Productos para la lista de compra ---------- */
  // unidades = lo que trae una unidad de venta (rollo en metros, par de bisagras = 2, pack de soportes = N)
  var productos = {
    tapacanto: (datos.tapacantos || []).map(function (t) {
      var m = /(\d+)\s*m(etros)?\b/i.exec(t.producto || '');
      t.unidades = m ? parseInt(m[1], 10) : 50;
      var e = /(\d+(?:[,.]\d+)?)\s*mm\b/i.exec(t.producto || '');
      t.espesor = e ? num(e[1]) : 0;
      return t;
    }),
    bisagras: (datos.bisagras || []).map(function (t) { t.unidades = 2; return t; }),
    correderas: (datos.correderas || []).map(function (t) { t.unidades = 1; return t; }),
    tiradores: (datos.tiradores || []).map(function (t) { t.unidades = 1; return t; }),
    discos: (datos.discos || []).map(function (t) { t.unidades = 1; return t; }),
    // solo tornillos para muebles (la colección también trae tornillos de techumbre y volcanita)
    tornillos: (datos.tornillos || []).filter(function (t) { return /chipboard|soberbio/i.test(t.producto || ''); }).map(function (t) {
      var m = /(\d+)\s*unidades/i.exec(t.producto || '');
      t.unidades = m ? parseInt(m[1], 10) : 1;
      return t;
    }),
    soportes: (datos.soportes || []).map(function (t) {
      var m = /(\d+)\s*unidades/i.exec(t.producto || '');
      t.unidades = m ? parseInt(m[1], 10) : 1;
      return t;
    })
  };
  productos.tapacanto2 = productos.tapacanto;
  var CONCEPTOS = [
    { k: 'tapacanto', titulo: 'Tapacanto', venta: ['rollo', 'rollos'] },
    { k: 'tapacanto2', titulo: 'Tapacanto secundario', venta: ['rollo', 'rollos'] },
    { k: 'bisagras', titulo: 'Bisagras', venta: ['par', 'pares'] },
    { k: 'correderas', titulo: 'Correderas', venta: ['par', 'pares'] },
    { k: 'tiradores', titulo: 'Tiradores', venta: ['unidad', 'unidades'] },
    { k: 'soportes', titulo: 'Soportes de repisa', venta: ['unidad de venta', 'unidades de venta'] },
    { k: 'tornillos', titulo: 'Tornillos para armar', venta: ['bolsa', 'bolsas'] },
    { k: 'discos', titulo: 'Disco de sierra (opcional)', venta: ['unidad', 'unidades'] }
  ];
  var TIPOS = [['pieza', 'Estructura'], ['puerta', 'Puerta'], ['cajon', 'Frente de cajón'], ['repisa', 'Repisa']];

  /* ---------- Estado ---------- */
  var nuevoMaterial = function (nombre) {
    return { nombre: nombre || '', tablero: '0', largo: tableros[0].largo, ancho: tableros[0].ancho, precio: null, retazos: [] };
  };
  var piezaVacia = function () { return { nombre: '', largo: null, ancho: null, cantidad: null, girar: true, cl: 0, ca: 0, tipo: 'pieza', mat: 0, tapa: 1 }; };
  var estadoInicial = function () {
    return {
      proyecto: { id: '', nombre: '', cliente: '' },
      materiales: [nuevoMaterial()],
      kerf: num(datos.kerf) || 3.2,
      refilado: 0,
      merma: 10,
      descontar: true,
      unidad: 'mm',
      ejemplo: false,
      compra: {},
      piezas: [piezaVacia()]
    };
  };
  var estado = estadoInicial();

  // Ordena y completa un estado guardado (también los de versiones anteriores, que tenían un solo tablero)
  function normalizar(g) {
    var e = Object.assign(estadoInicial(), g || {});
    if (!g || !g.materiales) {
      var m = nuevoMaterial();
      if (g && g.largo) { m.tablero = g.tablero || '0'; m.largo = g.largo; m.ancho = g.ancho; }
      e.materiales = [m];
    }
    e.materiales = e.materiales.map(function (m) { return Object.assign(nuevoMaterial(), m, { retazos: (m.retazos || []).slice() }); });
    e.proyecto = Object.assign({ id: '', nombre: '', cliente: '' }, e.proyecto || {});
    e.compra = e.compra || {};
    e.piezas = (e.piezas && e.piezas.length ? e.piezas : [piezaVacia()]).map(function (p) {
      var q = Object.assign(piezaVacia(), p);
      if (!(q.mat >= 0 && q.mat < e.materiales.length)) q.mat = 0;
      return q;
    });
    delete e.tablero; delete e.largo; delete e.ancho; delete e.tapacanto;
    return e;
  }

  try { estado = normalizar(JSON.parse(localStorage.getItem(CLAVE) || 'null')); } catch (e) { estado = estadoInicial(); }

  // Plan recibido por enlace (#plan=...): reemplaza lo guardado en este navegador
  var desdeEnlace = false;
  try {
    var mh = /[#&]plan=([^&]+)/.exec(location.hash);
    if (mh) {
      var d = JSON.parse(decodeURIComponent(escape(atob(mh[1].replace(/-/g, '+').replace(/_/g, '/')))));
      if (d && d.p && d.p.length) {
        var e = estadoInicial();
        if (d.v === 5) {
          e.materiales = d.mt.map(function (m) { return Object.assign(nuevoMaterial(), { nombre: m[0], largo: m[1], ancho: m[2], tablero: m[3], precio: m[4], retazos: (m[5] || []).map(function (r) { return { largo: r[0], ancho: r[1], cantidad: r[2] }; }) }); });
          e.proyecto = { id: '', nombre: (d.pj || [])[0] || '', cliente: (d.pj || [])[1] || '' };
          e.unidad = d.u || 'mm';
        } else {
          e.materiales = [Object.assign(nuevoMaterial(), { tablero: d.t[2], largo: d.t[0], ancho: d.t[1] })];
        }
        e.kerf = d.k; e.refilado = d.r; e.merma = d.m != null ? d.m : e.merma; e.descontar = d.d == null ? true : !!d.d;
        e.piezas = d.p.map(function (x) {
          return { nombre: x[0], largo: x[1], ancho: x[2], cantidad: x[3], girar: !!x[4], cl: x[5], ca: x[6], tipo: (TIPOS[x[7]] || TIPOS[0])[0], mat: x[8] || 0 };
        });
        Object.keys(d.c || {}).forEach(function (k) { e.compra[k] = { id: String(d.c[k]) }; });
        estado = normalizar(e);
        desdeEnlace = true;
      }
    }
  } catch (e) {}

  // Eventos para medir el uso (los recibe el píxel personalizado "Calculadora de cortes" en Eventos de clientes)
  var evento = function (nombre, info) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('calculadora_' + nombre, info || {}); } catch (e) {}
  };
  var U = function () { return estado.unidad === 'cm' ? 10 : 1; };
  var enUnidad = function (mm) { return mm ? String(Math.round(mm / U() * 100) / 100) : ''; };
  var guardar = function () { try { localStorage.setItem(CLAVE, JSON.stringify(estado)); } catch (e) {} };
  // Deshacer: se guarda una copia antes de borrar o reemplazar piezas, materiales o proyectos
  var copiaDeshacer = null;
  var respaldo = function (texto) {
    copiaDeshacer = JSON.stringify(estado);
    var el = $('[data-deshacer]');
    el.querySelector('[data-deshacer-texto]').textContent = texto;
    el.hidden = false;
    clearTimeout(respaldo.t); respaldo.t = setTimeout(function () { el.hidden = true; }, 9000);
  };
  var nombreMaterial = function (i) { var m = estado.materiales[i]; return (m && m.nombre.trim()) || (estado.materiales.length > 1 ? 'Material ' + (i + 1) : 'Tablero'); };

  /* ---------- Ayudas "?" ---------- */
  var AYUDAS = {
    tipo: 'Sirve para calcular los herrajes: cada puerta lleva bisagras y tirador, cada frente de cajón lleva un par de correderas y tirador, y cada repisa lleva soportes. Para laterales, techo, base o fondo, elige Estructura.',
    largo: 'Es el lado que va en el sentido de la veta o del diseño del tablero. En una puerta, es el alto.',
    cl: 'El tapacanto es la cinta que cubre los bordes de la pieza. Indica cuántos de sus dos lados largos van cubiertos. Por ejemplo, un lateral de mueble suele llevar 1 (el de adelante) y una puerta lleva los 2.',
    ca: 'Lo mismo, pero en los dos lados cortos de la pieza. Una puerta lleva los 2; una repisa interior normalmente ninguno.',
    girar: 'Déjalo marcado si da lo mismo hacia dónde quede la veta: así aprovechamos mejor el tablero. Desmárcalo si el tablero tiene veta o diseño (por ejemplo, imitación madera) y la pieza debe respetarlo.',
    material: 'Elige de qué tablero sale esta pieza. Cada material tiene su propio plan de corte.',
    precio: 'Opcional. Si lo ingresas, sumamos el costo de los tableros al costo total del mueble, junto con el tapacanto y los herrajes.',
    tapa: 'Elige cuál de los dos tapacantos del paso 3 lleva esta pieza. Por ejemplo, 1,5 mm para puertas y frentes, y 0,5 mm para el interior.',
    retazos: 'Si tienes sobrantes de este mismo material en el taller, ingrésalos y los usamos primero, antes de abrir un tablero nuevo.'
  };
  function botonAyuda(id, nombre) {
    return '<button type="button" class="cc-ayuda" data-ayuda="' + id + '" aria-expanded="false" aria-label="Qué significa ' + esc(nombre) + '">?</button>';
  }
  function textoAyuda(id, texto) { return '<p class="cc-ayuda-txt" id="' + id + '" hidden>' + texto + '</p>'; }
  function campo(id, etiqueta, control, ayuda) {
    return '<div class="cc-campo"><div class="cc-etiqueta"><label for="' + id + '">' + etiqueta + '</label>' + (ayuda ? botonAyuda(id + '-ayuda', etiqueta) : '') + '</div>' +
      control + (ayuda ? textoAyuda(id + '-ayuda', ayuda) : '') + '</div>';
  }
  raiz.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-ayuda]');
    if (!b) return;
    ev.preventDefault();
    var t = document.getElementById(b.getAttribute('data-ayuda'));
    if (!t) return;
    var abrir = t.hidden;
    t.hidden = !abrir;
    b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
  });

  /* ---------- Proyecto y Mis proyectos (guardados en este navegador) ---------- */
  var leerProyectos = function () { try { return JSON.parse(localStorage.getItem(CLAVE_PROYECTOS) || '[]'); } catch (e) { return []; } };
  var escribirProyectos = function (l) { try { localStorage.setItem(CLAVE_PROYECTOS, JSON.stringify(l)); return true; } catch (e) { return false; } };
  var avisoProyecto = function (t) {
    var el = $('[data-proyecto-ok]');
    el.textContent = t; el.hidden = false;
    clearTimeout(avisoProyecto.t); avisoProyecto.t = setTimeout(function () { el.hidden = true; }, 4000);
  };

  function pintarProyecto() {
    $('[data-proyecto-nombre]').value = estado.proyecto.nombre;
    $('[data-proyecto-cliente]').value = estado.proyecto.cliente;
    var l = leerProyectos();
    $('[data-proyectos-abrir]').textContent = 'Mis proyectos' + (l.length ? ' (' + l.length + ')' : '');
  }

  function pintarListaProyectos() {
    var l = leerProyectos().sort(function (a, b) { return b.fecha - a.fecha; });
    var cont = $('[data-proyectos-lista]');
    if (!l.length) { cont.innerHTML = '<p class="cc-nota">Aún no tienes proyectos guardados. Ponle nombre a tu proyecto y toca "Guardar proyecto".</p>'; return; }
    cont.innerHTML = l.map(function (p) {
      var f = new Date(p.fecha).toLocaleDateString('es-CL', { day: 'numeric', month: 'short', year: 'numeric' });
      return '<div class="cc-proy" data-proy="' + esc(p.id) + '"><div class="cc-proy__info"><strong>' + esc(p.nombre) + '</strong>' +
        '<span>' + (p.cliente ? esc(p.cliente) + ' · ' : '') + (p.estado.piezas || []).length + ' piezas · ' + f + '</span></div>' +
        '<div class="cc-proy__acciones"><button type="button" class="cc-quitar" data-proy-abrir>Abrir</button>' +
        '<button type="button" class="cc-quitar" data-proy-duplicar>Duplicar</button>' +
        '<button type="button" class="cc-quitar" data-proy-borrar>Borrar</button></div></div>';
    }).join('');
    cont.querySelectorAll('[data-proy]').forEach(function (fila) {
      var id = fila.getAttribute('data-proy');
      var buscar = function () { return leerProyectos().filter(function (p) { return p.id === id; })[0]; };
      fila.querySelector('[data-proy-abrir]').addEventListener('click', function () {
        var p = buscar(); if (!p) return;
        respaldo('Abriste "' + p.nombre + '".');
        estado = normalizar(p.estado); estado.proyecto.id = p.id;
        guardar(); pintarTodo(); $('[data-proyectos-panel]').hidden = true;
        $('[data-resultado]').hidden = true;
        avisoProyecto('Abriste "' + p.nombre + '".');
        evento('proyecto', { accion: 'abrir' });
      });
      fila.querySelector('[data-proy-duplicar]').addEventListener('click', function () {
        var p = buscar(); if (!p) return;
        var copia = JSON.parse(JSON.stringify(p));
        copia.id = 'p' + Date.now(); copia.nombre = p.nombre + ' (copia)'; copia.fecha = Date.now();
        copia.estado.proyecto = { id: copia.id, nombre: copia.nombre, cliente: p.cliente };
        var l = leerProyectos(); l.push(copia); escribirProyectos(l);
        pintarListaProyectos(); pintarProyecto();
        evento('proyecto', { accion: 'duplicar' });
      });
      fila.querySelector('[data-proy-borrar]').addEventListener('click', function () {
        var p = buscar(); if (!p) return;
        if (!window.confirm('¿Borrar el proyecto "' + p.nombre + '"? Esto no se puede deshacer.')) return;
        escribirProyectos(leerProyectos().filter(function (x) { return x.id !== id; }));
        if (estado.proyecto.id === id) { estado.proyecto.id = ''; guardar(); }
        pintarListaProyectos(); pintarProyecto();
      });
    });
  }

  $('[data-proyecto-nombre]').addEventListener('input', function (ev) { estado.proyecto.nombre = ev.target.value; guardar(); });
  $('[data-proyecto-cliente]').addEventListener('input', function (ev) { estado.proyecto.cliente = ev.target.value; guardar(); });
  $('[data-proyecto-guardar]').addEventListener('click', function () {
    var nombre = estado.proyecto.nombre.trim();
    if (!nombre) { $('[data-proyecto-nombre]').focus(); avisoProyecto('Ponle un nombre al proyecto para guardarlo.'); return; }
    var l = leerProyectos();
    var id = estado.proyecto.id && l.some(function (p) { return p.id === estado.proyecto.id; }) ? estado.proyecto.id : 'p' + Date.now();
    estado.proyecto.id = id;
    var copia = JSON.parse(JSON.stringify(estado));
    l = l.filter(function (p) { return p.id !== id; });
    l.push({ id: id, nombre: nombre, cliente: estado.proyecto.cliente.trim(), fecha: Date.now(), estado: copia });
    if (!escribirProyectos(l)) { avisoProyecto('Tu navegador no permitió guardar. Revisa que no estés en modo privado.'); return; }
    guardar(); pintarProyecto();
    if (!$('[data-proyectos-panel]').hidden) pintarListaProyectos();
    avisoProyecto('Proyecto guardado en este navegador.');
    evento('proyecto', { accion: 'guardar', proyectos: l.length });
  });
  $('[data-proyectos-abrir]').addEventListener('click', function () {
    var panel = $('[data-proyectos-panel]');
    panel.hidden = !panel.hidden;
    if (!panel.hidden) pintarListaProyectos();
  });
  $('[data-proyecto-nuevo]').addEventListener('click', function () {
    respaldo('Empezaste un proyecto nuevo.');
    estado = estadoInicial(); guardar(); pintarTodo();
    $('[data-resultado]').hidden = true;
  });

  /* ---------- Paso 1: materiales, tableros y retazos ---------- */
  function opcionesTablero() {
    return tableros.map(function (t, i) { return '<option value="' + i + '">' + fmt(t.largo) + ' × ' + fmt(t.ancho) + ' mm</option>'; }).join('') + '<option value="otra">Otra medida</option>';
  }

  function pintarMateriales() {
    var cont = $('[data-materiales]');
    var varios = estado.materiales.length > 1;
    cont.innerHTML = estado.materiales.map(function (m, i) {
      var id = 'cc-m' + i + '-';
      var ret = (m.retazos || []).map(function (r, j) {
        return '<div class="cc-retazo" data-retazo="' + j + '">' +
          campo(id + 'r' + j + 'l', 'Largo (mm)', '<input id="' + id + 'r' + j + 'l" type="number" inputmode="decimal" min="0" data-rk="largo" value="' + (r.largo || '') + '">') +
          campo(id + 'r' + j + 'a', 'Ancho (mm)', '<input id="' + id + 'r' + j + 'a" type="number" inputmode="decimal" min="0" data-rk="ancho" value="' + (r.ancho || '') + '">') +
          campo(id + 'r' + j + 'c', 'Cantidad', '<input id="' + id + 'r' + j + 'c" type="number" inputmode="numeric" min="1" data-rk="cantidad" value="' + (r.cantidad || '') + '">') +
          '<button type="button" class="cc-quitar" data-retazo-quitar="' + j + '">Quitar</button></div>';
      }).join('');
      return '<div class="cc-material" data-material="' + i + '">' +
        (varios ? '<div class="cc-pieza__cabecera"><span class="cc-pieza__n">Material ' + (i + 1) + '</span>' + (i > 0 ? '<button type="button" class="cc-quitar" data-material-quitar>Quitar</button>' : '') + '</div>' : '') +
        '<div class="cc-grilla cc-grilla--material">' +
        campo(id + 'nombre', 'Nombre del material', '<input id="' + id + 'nombre" type="text" data-mk="nombre" value="' + esc(m.nombre) + '" placeholder="Ej.: melamina blanca 18 mm">') +
        campo(id + 'tablero', 'Medida del tablero', '<select id="' + id + 'tablero" data-mk="tablero">' + opcionesTablero() + '</select>') +
        (m.tablero === 'otra' ? campo(id + 'largo', 'Largo del tablero (mm)', '<input id="' + id + 'largo" type="number" inputmode="decimal" min="1" data-mk="largo" value="' + (m.largo || '') + '">') +
          campo(id + 'ancho', 'Ancho del tablero (mm)', '<input id="' + id + 'ancho" type="number" inputmode="decimal" min="1" data-mk="ancho" value="' + (m.ancho || '') + '">') : '') +
        campo(id + 'precio', 'Precio por tablero ($)', '<input id="' + id + 'precio" type="number" inputmode="numeric" min="0" data-mk="precio" value="' + (m.precio || '') + '" placeholder="Opcional">', AYUDAS.precio) +
        '</div>' +
        '<div class="cc-retazos">' +
        (ret ? '<p class="cc-retazos__titulo">Retazos disponibles</p>' + ret : '') +
        '<div class="cc-check-fila"><button type="button" class="cc-enlace" data-retazo-agregar>' + (ret ? 'Agregar otro retazo' : 'Tengo retazos de este material') + '</button>' + botonAyuda(id + 'ret-ayuda', 'Retazos') + '</div>' +
        textoAyuda(id + 'ret-ayuda', AYUDAS.retazos) + '</div></div>';
    }).join('');
    cont.querySelectorAll('[data-material]').forEach(function (card) {
      var i = parseInt(card.getAttribute('data-material'), 10), m = estado.materiales[i];
      var sel = card.querySelector('[data-mk="tablero"]'); sel.value = m.tablero;
      card.addEventListener('input', function (ev) {
        var k = ev.target.getAttribute('data-mk'), rk = ev.target.getAttribute('data-rk');
        if (k === 'nombre') { m.nombre = ev.target.value; pintarSelectMateriales(); }
        else if (k === 'largo' || k === 'ancho' || k === 'precio') m[k] = num(ev.target.value) || null;
        else if (rk) { var j = parseInt(ev.target.closest('[data-retazo]').getAttribute('data-retazo'), 10); m.retazos[j][rk] = num(ev.target.value) || null; }
        guardar();
      });
      sel.addEventListener('change', function () {
        m.tablero = sel.value;
        if (m.tablero !== 'otra') { var t = tableros[parseInt(m.tablero, 10)]; m.largo = t.largo; m.ancho = t.ancho; }
        guardar(); pintarMateriales();
      });
      var q = card.querySelector('[data-material-quitar]');
      if (q) q.addEventListener('click', function () {
        respaldo('Material eliminado.');
        estado.materiales.splice(i, 1);
        estado.piezas.forEach(function (p) { if (p.mat === i) p.mat = 0; else if (p.mat > i) p.mat--; });
        guardar(); pintarMateriales(); pintarPiezas();
      });
      card.querySelector('[data-retazo-agregar]').addEventListener('click', function () {
        m.retazos.push({ largo: null, ancho: null, cantidad: 1 });
        guardar(); pintarMateriales();
        var r = raiz.querySelectorAll('[data-material="' + i + '"] [data-retazo]');
        if (r.length) r[r.length - 1].querySelector('input').focus();
      });
      card.querySelectorAll('[data-retazo-quitar]').forEach(function (b) {
        b.addEventListener('click', function () { respaldo('Retazo eliminado.'); m.retazos.splice(parseInt(b.getAttribute('data-retazo-quitar'), 10), 1); guardar(); pintarMateriales(); });
      });
    });
  }

  $('[data-material-agregar]').addEventListener('click', function () {
    estado.materiales.push(nuevoMaterial());
    guardar(); pintarMateriales(); pintarPiezas();
    var cards = raiz.querySelectorAll('[data-material]');
    var inp = cards[cards.length - 1].querySelector('[data-mk="nombre"]'); if (inp) inp.focus();
  });
  [['[data-kerf]', 'kerf'], ['[data-refilado]', 'refilado']].forEach(function (par) {
    $(par[0]).addEventListener('input', function (ev) { estado[par[1]] = num(ev.target.value); guardar(); });
  });

  $('[data-deshacer-boton]').addEventListener('click', function () {
    if (!copiaDeshacer) return;
    estado = normalizar(JSON.parse(copiaDeshacer)); copiaDeshacer = null;
    guardar(); pintarTodo();
    $('[data-deshacer]').hidden = true;
  });

  // Barra fija en celular con el total de piezas y el botón Calcular
  function contarPiezas() {
    var n = estado.piezas.reduce(function (t, p) { return t + (p.largo > 0 && p.ancho > 0 && p.cantidad > 0 ? Math.round(p.cantidad) : 0); }, 0);
    var el = $('[data-barra-n]');
    if (el) el.textContent = n ? n + (n === 1 ? ' pieza' : ' piezas') : 'Sin piezas aún';
  }
  (function () {
    var barra = $('[data-barra]'), boton = $('[data-calcular]'), res = $('[data-resultado]');
    if (!barra || !('IntersectionObserver' in window)) return;
    var vis = { boton: false, res: false };
    var actualizar = function () { barra.classList.toggle('cc-barra--visible', !vis.boton && !vis.res); };
    new IntersectionObserver(function (e) { vis.boton = e[0].isIntersecting; actualizar(); }).observe(boton);
    new IntersectionObserver(function (e) { vis.res = e[0].isIntersecting; actualizar(); }).observe(res);
    barra.querySelector('button').addEventListener('click', function () { calcular(false); });
  })();

  /* ---------- Paso 3: tapacanto ---------- */
  var selTapa = $('[data-tapa-form]');
  selTapa.innerHTML = '<option value="">Elige una opción</option><option value="no">Sin tapacanto</option>' +
    productos.tapacanto.map(function (t) {
      return '<option value="' + t.id + '"' + (t.disponible ? '' : ' disabled') + '>' + esc(t.nombre) + ' · ' + dinero(t.precio) + (t.disponible ? '' : ' (sin stock)') + '</option>';
    }).join('');
  selTapa.addEventListener('change', function () { estado.compra.tapacanto = { id: selTapa.value }; selTapa.classList.remove('cc-falta'); $('[data-tapa-aviso]').hidden = true; guardar(); });
  var selTapa2 = $('[data-tapa2-form]');
  selTapa2.innerHTML = '<option value="">No uso un segundo tapacanto</option>' +
    productos.tapacanto.map(function (t) {
      return '<option value="' + t.id + '"' + (t.disponible ? '' : ' disabled') + '>' + esc(t.nombre) + ' · ' + dinero(t.precio) + (t.disponible ? '' : ' (sin stock)') + '</option>';
    }).join('');
  selTapa2.addEventListener('change', function () { estado.compra.tapacanto2 = { id: selTapa2.value }; guardar(); pintarPiezas(); });
  $('[data-merma]').addEventListener('input', function (ev) { estado.merma = num(ev.target.value); guardar(); });
  $('[data-descontar]').addEventListener('change', function (ev) { estado.descontar = ev.target.checked; guardar(); });

  function pintarTodo() {
    pintarProyecto();
    pintarMateriales();
    $('[data-kerf]').value = String(estado.kerf).replace('.', ',');
    $('[data-refilado]').value = estado.refilado;
    $('[data-merma]').value = estado.merma;
    $('[data-descontar]').checked = !!estado.descontar;
    var tapa = estado.compra.tapacanto && estado.compra.tapacanto.id;
    selTapa.value = tapa === 'no' || elegido('tapacanto') ? String(tapa) : '';
    selTapa2.value = elegido('tapacanto2') ? String(estado.compra.tapacanto2.id) : '';
    pintarPiezas();
  }

  /* ---------- Paso 2: piezas ---------- */
  function opcionesMaterial() {
    return estado.materiales.map(function (m, i) { return '<option value="' + i + '">' + esc(nombreMaterial(i)) + '</option>'; }).join('');
  }
  function pintarSelectMateriales() {
    raiz.querySelectorAll('[data-k="mat"]').forEach(function (s) { var v = s.value; s.innerHTML = opcionesMaterial(); s.value = v; });
  }

  function pintarPiezas() {
    var cuerpo = $('[data-piezas]');
    cuerpo.innerHTML = '';
    var varios = estado.materiales.length > 1;
    var dosTapas = !!elegido('tapacanto2');
    estado.piezas.forEach(function (p, i) {
      var fila = document.createElement('div');
      fila.className = 'cc-pieza';
      var id = 'cc-p' + i + '-';
      var lados = '<option value="0">Ninguno</option><option value="1">1 lado</option><option value="2">2 lados</option>';
      fila.innerHTML =
        '<div class="cc-pieza__cabecera"><span class="cc-pieza__n">Pieza ' + (i + 1) + '</span>' +
        '<span class="cc-pieza__acciones"><button type="button" class="cc-quitar" data-duplicar="' + i + '" aria-label="Duplicar pieza ' + (i + 1) + '">Duplicar</button>' +
        (estado.piezas.length > 1 ? '<button type="button" class="cc-quitar" data-quitar="' + i + '" aria-label="Quitar pieza ' + (i + 1) + '">Quitar</button>' : '') + '</span></div>' +
        '<div class="cc-pieza__fila cc-pieza__fila--1">' +
        campo(id + 'nombre', 'Nombre', '<input id="' + id + 'nombre" type="text" data-k="nombre" value="' + esc(p.nombre) + '" placeholder="Ej.: lateral, puerta, repisa">') +
        campo(id + 'tipo', 'Tipo de pieza', '<select id="' + id + 'tipo" data-k="tipo">' + TIPOS.map(function (t) { return '<option value="' + t[0] + '">' + t[1] + '</option>'; }).join('') + '</select>', AYUDAS.tipo) +
        campo(id + 'largo', 'Largo (' + estado.unidad + ')', '<input id="' + id + 'largo" type="number" inputmode="decimal" min="0" step="any" data-k="largo" value="' + enUnidad(p.largo) + '">', AYUDAS.largo) +
        campo(id + 'ancho', 'Ancho (' + estado.unidad + ')', '<input id="' + id + 'ancho" type="number" inputmode="decimal" min="0" step="any" data-k="ancho" value="' + enUnidad(p.ancho) + '">') +
        campo(id + 'cantidad', 'Cantidad', '<input id="' + id + 'cantidad" type="number" inputmode="numeric" min="1" data-k="cantidad" value="' + (p.cantidad || '') + '">') +
        '</div><div class="cc-pieza__fila cc-pieza__fila--2' + (varios || dosTapas ? ' cc-pieza__fila--auto' : '') + '">' +
        (varios ? campo(id + 'mat', 'Material', '<select id="' + id + 'mat" data-k="mat">' + opcionesMaterial() + '</select>', AYUDAS.material) : '') +
        (dosTapas ? campo(id + 'tapa', 'Tapacanto', '<select id="' + id + 'tapa" data-k="tapa"><option value="1">Principal</option><option value="2">Secundario</option></select>', AYUDAS.tapa) : '') +
        campo(id + 'cl', 'Canto en lados largos', '<select id="' + id + 'cl" data-k="cl">' + lados + '</select>', AYUDAS.cl) +
        campo(id + 'ca', 'Canto en lados cortos', '<select id="' + id + 'ca" data-k="ca">' + lados + '</select>', AYUDAS.ca) +
        '<div><div class="cc-check-fila"><label class="cc-check"><input type="checkbox" data-k="girar"' + (p.girar ? ' checked' : '') + '><span>Se puede girar</span></label>' +
        botonAyuda(id + 'girar-ayuda', 'Se puede girar') + '</div>' + textoAyuda(id + 'girar-ayuda', AYUDAS.girar) + '</div>' +
        '</div>';
      fila.querySelector('[data-k="cl"]').value = String(p.cl || 0);
      fila.querySelector('[data-k="ca"]').value = String(p.ca || 0);
      fila.querySelector('[data-k="tipo"]').value = p.tipo || 'pieza';
      if (varios) fila.querySelector('[data-k="mat"]').value = String(p.mat || 0);
      if (dosTapas) fila.querySelector('[data-k="tapa"]').value = String(p.tapa || 1);
      var leer = function (ev) {
        var k = ev.target.getAttribute('data-k');
        if (!k) return;
        if (k === 'girar') p.girar = ev.target.checked;
        else if (k === 'nombre' || k === 'tipo') p[k] = ev.target.value;
        else if (k === 'largo' || k === 'ancho') p[k] = num(ev.target.value) * U();
        else p[k] = num(ev.target.value);
        guardar();
        if (k === 'cantidad' || k === 'largo' || k === 'ancho') contarPiezas();
      };
      fila.addEventListener('input', leer);
      fila.addEventListener('change', leer);
      cuerpo.appendChild(fila);
    });
    cuerpo.querySelectorAll('[data-duplicar]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-duplicar'), 10);
        estado.piezas.splice(i + 1, 0, Object.assign({}, estado.piezas[i]));
        guardar(); pintarPiezas();
        var nueva = raiz.querySelectorAll('[data-piezas] .cc-pieza')[i + 1];
        if (nueva) { nueva.scrollIntoView({ behavior: 'smooth', block: 'center' }); var inp = nueva.querySelector('[data-k="largo"]'); if (inp) inp.focus(); }
      });
    });
    cuerpo.querySelectorAll('[data-quitar]').forEach(function (b) {
      b.addEventListener('click', function () {
        respaldo('Pieza ' + (parseInt(b.getAttribute('data-quitar'), 10) + 1) + ' eliminada.');
        estado.piezas.splice(parseInt(b.getAttribute('data-quitar'), 10), 1);
        guardar(); pintarPiezas();
      });
    });
    contarPiezas();
    raiz.querySelectorAll('[data-unidad]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-unidad') === estado.unidad ? 'true' : 'false'); });
    $('[data-ejemplo-aviso]').hidden = !estado.ejemplo;
  }

  $('[data-agregar]').addEventListener('click', function () {
    var ultimaMat = estado.piezas.length ? estado.piezas[estado.piezas.length - 1].mat : 0;
    var p = piezaVacia(); p.mat = ultimaMat;
    estado.piezas.push(p);
    guardar(); pintarPiezas();
    var inputs = raiz.querySelectorAll('[data-piezas] .cc-pieza:last-child input');
    if (inputs[0]) inputs[0].focus();
  });
  var limpiar = function () {
    estado.piezas = [piezaVacia()];
    estado.ejemplo = false;
    guardar(); pintarPiezas();
    $('[data-resultado]').hidden = true;
  };
  $('[data-limpiar]').addEventListener('click', function () {
    if (!estado.piezas.some(function (p) { return p.largo || p.ancho; })) return;
    respaldo('Borraste todas las piezas.');
    limpiar();
  });
  $('[data-ejemplo-borrar]').addEventListener('click', function () { limpiar(); evento('ejemplo_borrado'); });
  raiz.querySelectorAll('[data-unidad]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (estado.unidad === b.getAttribute('data-unidad')) return;
      estado.unidad = b.getAttribute('data-unidad');
      guardar(); pintarPiezas();
      evento('unidad', { unidad: estado.unidad });
    });
  });
  // Ejemplo: un mueble base de cocina, marcado como ejemplo en cada nombre para que nadie lo corte por error
  $('[data-ejemplo]').addEventListener('click', function () {
    if (estado.piezas.some(function (p) { return p.largo || p.ancho; })) respaldo('Cargaste el ejemplo en lugar de tus piezas.');
    estado.piezas = [
      { nombre: 'Ejemplo: lateral', largo: 720, ancho: 560, cantidad: 2, girar: true, cl: 1, ca: 0, tipo: 'pieza', mat: 0 },
      { nombre: 'Ejemplo: base', largo: 764, ancho: 560, cantidad: 1, girar: true, cl: 1, ca: 0, tipo: 'pieza', mat: 0 },
      { nombre: 'Ejemplo: amarre', largo: 764, ancho: 100, cantidad: 2, girar: true, cl: 1, ca: 0, tipo: 'pieza', mat: 0 },
      { nombre: 'Ejemplo: repisa', largo: 762, ancho: 520, cantidad: 1, girar: true, cl: 1, ca: 0, tipo: 'repisa', mat: 0 },
      { nombre: 'Ejemplo: puerta', largo: 716, ancho: 397, cantidad: 2, girar: false, cl: 2, ca: 2, tipo: 'puerta', mat: 0 }
    ];
    estado.ejemplo = true;
    estado.unidad = 'mm';
    var tapa = productos.tapacanto.filter(function (t) { return t.disponible && /1,5 mm/.test(t.nombre) && /22 mm/.test(t.nombre); })[0] || productos.tapacanto.filter(function (t) { return t.disponible; })[0];
    estado.compra.tapacanto = { id: tapa ? String(tapa.id) : 'no' };
    guardar(); pintarTodo();
    evento('ejemplo');
    calcular(true);
  });

  /* ---------- Cálculo: acomodo libre con espesor de disco (respaldo) ---------- */
  function empacar(lista, W, H, kerf, orden, regla) {
    var piezas = lista.slice().sort(orden);
    var tabs = [];
    var noCaben = [];
    piezas.forEach(function (p) {
      var mejor = null;
      for (var b = 0; b < tabs.length && !mejor; b++) mejor = buscar(tabs[b], p, b);
      if (!mejor) {
        var nuevo = { libres: [{ x: 0, y: 0, w: W, h: H }], puestas: [] };
        var m = buscar(nuevo, p, tabs.length);
        if (!m) { noCaben.push(p); return; }
        tabs.push(nuevo); mejor = m;
      }
      colocar(tabs[mejor.b], mejor, p, kerf, regla);
    });
    return { tableros: tabs, noCaben: noCaben };

    function buscar(tab, p, b) {
      var mejor = null;
      tab.libres.forEach(function (r, i) {
        var opciones = [[p.largo, p.ancho, false]];
        if (p.girar && p.largo !== p.ancho) opciones.push([p.ancho, p.largo, true]);
        opciones.forEach(function (o) {
          if (o[0] <= r.w + 0.001 && o[1] <= r.h + 0.001) {
            var sobra = r.w * r.h - o[0] * o[1];
            var corto = Math.min(r.w - o[0], r.h - o[1]);
            if (!mejor || sobra < mejor.sobra || (sobra === mejor.sobra && corto < mejor.corto)) {
              mejor = { b: b, i: i, w: o[0], h: o[1], girada: o[2], sobra: sobra, corto: corto };
            }
          }
        });
      });
      return mejor;
    }
  }

  function colocar(tab, m, p, kerf, regla) {
    var r = tab.libres[m.i];
    tab.puestas.push({ x: r.x, y: r.y, w: m.w, h: m.h, n: p.n, nombre: p.nombre, girada: m.girada, largo: p.largo, ancho: p.ancho, fl: p.fl, fa: p.fa, cl: p.cl, ca: p.ca, mat: p.mat });
    tab.libres.splice(m.i, 1);
    var restoW = r.w - m.w - kerf;
    var restoH = r.h - m.h - kerf;
    var horizontal = regla === 'corto' ? (r.w - m.w) <= (r.h - m.h) : (r.w - m.w) > (r.h - m.h);
    var derecha, abajo;
    if (horizontal) {
      derecha = { x: r.x + m.w + kerf, y: r.y, w: restoW, h: m.h };
      abajo = { x: r.x, y: r.y + m.h + kerf, w: r.w, h: restoH };
    } else {
      derecha = { x: r.x + m.w + kerf, y: r.y, w: restoW, h: r.h };
      abajo = { x: r.x, y: r.y + m.h + kerf, w: m.w, h: restoH };
    }
    [derecha, abajo].forEach(function (n) { if (n.w > 0.5 && n.h > 0.5) tab.libres.push(n); });
  }

  /* ---------- Optimizador por franjas (como se corta en escuadradora) ----------
     1.er corte: franjas de lado a lado del tablero. 2.º corte: cada franja en columnas.
     3.er corte: columnas con varias piezas apiladas. Cada franja se llena con la mejor
     combinación de piezas (mochila exacta en milímetros). Se prueban franjas a lo largo
     y a lo ancho y muchas variantes; gana el plan con menos tableros, luego el que deja
     el retazo aprovechable más grande y luego el que tiene menos cortes. */
  function tiposDe(lista) {
    var mapa = {}, tipos = [];
    lista.forEach(function (p) {
      var k = p.n + '|' + p.largo + '|' + p.ancho + '|' + (p.girar ? 1 : 0);
      if (!mapa[k]) { mapa[k] = { largo: p.largo, ancho: p.ancho, girar: p.girar, piezas: [] }; tipos.push(mapa[k]); }
      mapa[k].piezas.push(p);
    });
    return tipos;
  }

  // modo 'h': franjas a lo largo del tablero (eje x); modo 'v': franjas a lo ancho (eje y)
  function opcionesDe(t, modo) {
    var nat = modo === 'h' ? [t.largo, t.ancho, false] : [t.ancho, t.largo, false];
    var ops = [nat];
    if (t.girar && t.largo !== t.ancho) ops.push([nat[1], nat[0], true]);
    return ops;
  }

  function llenarFranja(tipos, cnt, h, BW, kerf, modo) {
    var C = Math.floor(BW + kerf + 1e-6);
    var items = [];
    tipos.forEach(function (t, ti) {
      if (!cnt[ti]) return;
      var mejor = null;
      opcionesDe(t, modo).forEach(function (o) {
        if (o[0] > BW + 1e-6 || o[1] > h + 1e-6) return;
        var s = Math.min(cnt[ti], Math.floor((h + kerf + 1e-6) / (o[1] + kerf)));
        var relleno = (s * o[1] + (s - 1) * kerf) / h;
        if (!mejor || relleno > mejor.relleno + 1e-9 || (Math.abs(relleno - mejor.relleno) < 1e-9 && o[0] < mejor.o[0])) mejor = { o: o, s: s, relleno: relleno };
      });
      if (!mejor) return;
      var largo = Math.floor(mejor.o[0] + kerf + 1e-6);
      var copias = Math.min(Math.floor(cnt[ti] / mejor.s), Math.floor(C / largo));
      for (var c = 0; c < copias; c++) items.push({ ti: ti, o: mejor.o, s: mejor.s, len: largo, val: mejor.s * mejor.o[0] * mejor.o[1] });
      var resto = cnt[ti] - Math.floor(cnt[ti] / mejor.s) * mejor.s;
      if (resto > 0 && copias === Math.floor(cnt[ti] / mejor.s)) items.push({ ti: ti, o: mejor.o, s: resto, len: largo, val: resto * mejor.o[0] * mejor.o[1] });
    });
    if (!items.length) return null;
    // mochila 0/1 sobre el largo de la franja
    var n = items.length, dp = new Float64Array(C + 1), toma = new Uint8Array(n * (C + 1));
    for (var i = 0; i < n; i++) {
      var L = items[i].len, v = items[i].val, base = i * (C + 1);
      for (var c2 = C; c2 >= L; c2--) {
        if (dp[c2 - L] + v > dp[c2] + 1e-9) { dp[c2] = dp[c2 - L] + v; toma[base + c2] = 1; }
      }
    }
    var cap = C, elegidos = [];
    for (var j = n - 1; j >= 0; j--) if (toma[j * (C + 1) + cap]) { elegidos.push(items[j]); cap -= items[j].len; }
    // la mochila usa milímetros enteros (redondeo hacia abajo): si el largo exacto no cabe, se saca la columna de menor valor
    var exacto = function () { return elegidos.reduce(function (t, it) { return t + it.o[0] + kerf; }, 0); };
    while (elegidos.length && exacto() > BW + kerf + 1e-6) {
      var menor = 0;
      elegidos.forEach(function (it, i) { if (it.val < elegidos[menor].val) menor = i; });
      elegidos.splice(menor, 1);
    }
    if (!elegidos.length) return null;
    // columnas de mayor a menor ancho; en el espacio sobrante de cada columna se apilan otras piezas
    elegidos.sort(function (a, b) { return b.o[0] - a.o[0]; });
    var usados = cnt.slice(), area = 0, x = 0, cols = [];
    elegidos.forEach(function (it) { usados[it.ti] -= it.s; });
    elegidos.forEach(function (it) {
      var col = { x: x, w: it.o[0], piezas: [] }, y = 0;
      for (var k = 0; k < it.s; k++) { col.piezas.push({ ti: it.ti, y: y, w: it.o[0], h: it.o[1], girada: it.o[2] }); y += it.o[1] + kerf; area += it.o[0] * it.o[1]; }
      var libre = h - y;
      for (;;) {
        var mejor = null;
        tipos.forEach(function (t, ti) {
          if (!usados[ti]) return;
          opcionesDe(t, modo).forEach(function (o) {
            if (o[0] <= col.w + 1e-6 && o[1] <= libre + 1e-6 && (!mejor || o[0] * o[1] > mejor.a)) mejor = { ti: ti, o: o, a: o[0] * o[1] };
          });
        });
        if (!mejor) break;
        usados[mejor.ti]--;
        col.piezas.push({ ti: mejor.ti, y: y, w: mejor.o[0], h: mejor.o[1], girada: mejor.o[2] });
        area += mejor.a; y += mejor.o[1] + kerf; libre = h - y;
      }
      cols.push(col);
      x += it.o[0] + kerf;
    });
    return { h: h, cols: cols, area: area, usados: usados, largoUsado: Math.max(0, x - kerf) };
  }

  // retazos: sobrantes del taller ({w, h} útiles) que se usan antes de abrir tableros nuevos
  function porFranjas(lista, W, H, kerf, modo, sesgo, ruido, azar, retazos) {
    retazos = retazos || [];
    var tipos = tiposDe(lista), cnt = tipos.map(function (t) { return t.piezas.length; });
    var tabs = [], noCaben = [], k = 0;
    var quedan = function () { return cnt.some(function (c) { return c > 0; }); };
    while (quedan()) {
      var esRetazo = k < retazos.length;
      var TW = esRetazo ? retazos[k].w : W, TH = esRetazo ? retazos[k].h : H;
      var BW = modo === 'h' ? TW : TH, BH = modo === 'h' ? TH : TW;
      k++;
      var franjas = [], y = 0;
      for (;;) {
        var disp = BH - y, alturas = [];
        tipos.forEach(function (t, ti) {
          if (!cnt[ti]) return;
          opcionesDe(t, modo).forEach(function (o) { if (o[0] <= BW + 1e-6 && o[1] <= disp + 1e-6 && alturas.indexOf(o[1]) === -1) alturas.push(o[1]); });
        });
        alturas.sort(function (a, b) { return b - a; });
        var mejor = null;
        alturas.slice(0, 8).forEach(function (h) {
          var f = llenarFranja(tipos, cnt, h, BW, kerf, modo);
          if (!f) return;
          var puntaje = f.area / (BW * h) + sesgo * (h / BH) + (ruido ? (azar() - 0.5) * ruido : 0);
          if (!mejor || puntaje > mejor.puntaje) { mejor = f; mejor.puntaje = puntaje; }
        });
        if (!mejor) break;
        cnt = mejor.usados;
        mejor.y = y;
        franjas.push(mejor);
        y += mejor.h + kerf;
      }
      if (!franjas.length) {
        if (esRetazo) continue;
        tipos.forEach(function (t, ti) { if (cnt[ti]) { noCaben = noCaben.concat(t.piezas.slice(0, cnt[ti])); cnt[ti] = 0; } });
        break;
      }
      tabs.push({ franjas: franjas, alto: y - kerf, BW: BW, BH: BH, W: TW, H: TH, retazo: esRetazo });
    }
    // asignar las piezas reales y pasar a coordenadas del tablero
    var tomadas = tipos.map(function () { return 0; });
    var cortes = 0, retazo = 0;
    var tableros = tabs.map(function (tb) {
      var puestas = [], BW = tb.BW, BH = tb.BH;
      tb.franjas.forEach(function (f) {
        cortes++;
        f.cols.forEach(function (col) {
          cortes++;
          col.piezas.forEach(function (q) {
            cortes++;
            var p = tipos[q.ti].piezas[tomadas[q.ti]++];
            q.p = p;
            var ax = col.x, ay = f.y + q.y;
            var r = modo === 'h' ? { x: ax, y: ay, w: q.w, h: q.h } : { x: ay, y: ax, w: q.h, h: q.w };
            puestas.push({ x: r.x, y: r.y, w: r.w, h: r.h, n: p.n, nombre: p.nombre, girada: q.girada, largo: p.largo, ancho: p.ancho, fl: p.fl, fa: p.fa, cl: p.cl, ca: p.ca, mat: p.mat });
          });
        });
        retazo = Math.max(retazo, (BW - f.largoUsado - kerf) * f.h);
      });
      retazo = Math.max(retazo, BW * (BH - tb.alto - kerf));
      return { puestas: puestas, franjas: tb.franjas, modo: modo, BW: BW, BH: BH, alto: tb.alto, W: tb.W, H: tb.H, retazo: tb.retazo };
    });
    return { tableros: tableros, noCaben: noCaben, cortes: cortes, retazo: retazo, secuencia: true };
  }

  function nuevos(r) { return r.tableros.filter(function (t) { return !t.retazo; }).length; }
  function mejorQue(a, b, areaTab) {
    if (!b) return true;
    if (a.noCaben.length !== b.noCaben.length) return a.noCaben.length < b.noCaben.length;
    if (nuevos(a) !== nuevos(b)) return nuevos(a) < nuevos(b);
    if (a.tableros.length !== b.tableros.length) return a.tableros.length < b.tableros.length;
    if (Math.abs(a.retazo - b.retazo) > areaTab * 0.02) return a.retazo > b.retazo;
    if (a.cortes !== b.cortes) return a.cortes < b.cortes;
    return a.retazo > b.retazo;
  }

  function optimizar(lista, W, H, kerf, retazos) {
    retazos = (retazos || []).slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; });
    var areaTab = W * H, mejor = null, inicio = Date.now();
    var semilla = 7;
    var azar = function () { semilla = (semilla * 16807) % 2147483647; return semilla / 2147483647; };
    var probar = function (r) { if (mejorQue(r, mejor, areaTab)) mejor = r; };
    ['h', 'v'].forEach(function (modo) {
      [0, 0.1, 0.25, 0.5, 1].forEach(function (sesgo) { probar(porFranjas(lista, W, H, kerf, modo, sesgo, 0, azar, retazos)); });
    });
    for (var it = 0; it < 150 && Date.now() - inicio < 1500; it++) {
      probar(porFranjas(lista, W, H, kerf, it % 2 ? 'v' : 'h', azar() * 0.6, 0.05 + azar() * 0.2, azar, retazos));
    }
    // respaldo: acomodo libre (también guillotina); solo gana si usa menos tableros
    var libre = retazos.length ? null : planLibre(lista, W, H, kerf);
    if (libre && (libre.noCaben.length < mejor.noCaben.length || (libre.noCaben.length === mejor.noCaben.length && libre.tableros.length < mejor.tableros.length))) mejor = libre;
    var areaPiezas = lista.reduce(function (s, p) { return s + p.largo * p.ancho; }, 0);
    mejor.minimo = retazos.length ? null : Math.ceil(areaPiezas / areaTab - 1e-9);
    mejor.tableros.forEach(function (t) { t.W = t.W || W; t.H = t.H || H; });
    mejor.nuevos = nuevos(mejor);
    return mejor;
  }

  // acomodo libre con rectángulos sobrantes (versión anterior), como respaldo del optimizador por franjas
  function planLibre(lista, W, H, kerf) {
    var ordenes = [
      function (a, b) { return b.largo * b.ancho - a.largo * a.ancho; },
      function (a, b) { return Math.max(b.largo, b.ancho) - Math.max(a.largo, a.ancho); },
      function (a, b) { return b.largo - a.largo || b.ancho - a.ancho; },
      function (a, b) { return b.ancho - a.ancho || b.largo - a.largo; }
    ];
    // Además de los órdenes fijos, prueba órdenes por área con variación aleatoria (semilla fija: mismo resultado cada vez)
    var semilla = 7;
    var azar = function () { semilla = (semilla * 16807) % 2147483647; return semilla / 2147483647; };
    for (var it = 0; it < 40; it++) {
      var ruido = {};
      lista.forEach(function (p, i) { ruido[i] = 0.6 + azar() * 0.8; p._i = i; });
      ordenes.push((function (rz) { return function (a, b) { return b.largo * b.ancho * rz[b._i] - a.largo * a.ancho * rz[a._i]; }; })(ruido));
    }
    var mejor = null;
    ordenes.forEach(function (o) {
      ['corto', 'largo'].forEach(function (regla) {
        var r = empacar(lista, W, H, kerf, o, regla);
        var n = r.tableros.length;
        var ult = n ? r.tableros[n - 1].puestas.reduce(function (s, q) { return s + q.w * q.h; }, 0) : 0;
        var clave = [r.noCaben.length, n, ult];
        if (!mejor || clave[0] < mejor.clave[0] || (clave[0] === mejor.clave[0] && (clave[1] < mejor.clave[1] || (clave[1] === mejor.clave[1] && clave[2] < mejor.clave[2])))) {
          mejor = { r: r, clave: clave };
        }
      });
    });
    var r = mejor.r;
    var retazo = 0;
    r.tableros.forEach(function (t) { t.libres.forEach(function (l) { retazo = Math.max(retazo, l.w * l.h); }); });
    return { tableros: r.tableros, noCaben: r.noCaben, cortes: lista.length * 2, retazo: retazo, secuencia: false };
  }

  /* ---------- Lista de compra: tapacanto y herrajes ---------- */
  // Bisagras por puerta según su altura (largo): hasta 900 mm 2, hasta 1.600 mm 3, hasta 2.000 mm 4, más 5.
  function bisagrasPorPuerta(alto) { return alto <= 900 ? 2 : alto <= 1600 ? 3 : alto <= 2000 ? 4 : 5; }

  function necesidades(lista) {
    var mm = 0, mm2 = 0, puertas = 0, bisagras = 0, cajones = 0, repisas = 0, estructura = 0;
    var dosTapas = !!elegido('tapacanto2');
    lista.forEach(function (p) {
      var largoCanto = p.fl * p.cl + p.fa * p.ca;
      if (dosTapas && p.tapa === 2) mm2 += largoCanto; else mm += largoCanto;
      if (p.tipo === 'pieza') estructura++;
      if (p.tipo === 'puerta') { puertas++; bisagras += bisagrasPorPuerta(p.largo); }
      if (p.tipo === 'cajon') cajones++;
      if (p.tipo === 'repisa') repisas++;
    });
    var extra = 1 + Math.max(0, estado.merma) / 100;
    var metros = mm / 1000 * extra, metros2 = mm2 / 1000 * extra;
    var tornillos = estructura * 4;
    return {
      tapacanto: { base: metros, detalle: fmt(mm / 1000, 1) + ' m de cantos + ' + fmt(estado.merma) + ' % para recortes = ' + fmt(metros, 1) + ' m' + (dosTapas ? ' (piezas con el tapacanto principal)' : '') },
      tapacanto2: { base: metros2, detalle: fmt(mm2 / 1000, 1) + ' m de cantos + ' + fmt(estado.merma) + ' % para recortes = ' + fmt(metros2, 1) + ' m (piezas con el tapacanto secundario)' },
      tornillos: { base: tornillos, detalle: estructura + (estructura === 1 ? ' pieza' : ' piezas') + ' de estructura → unos ' + tornillos + ' tornillos (4 por pieza). Para unir tableros de 18 mm se usa normalmente tornillo de 40 a 50 mm de largo. Ajusta según tu armado.' },
      bisagras: { base: bisagras, detalle: puertas + (puertas === 1 ? ' puerta' : ' puertas') + ' → ' + bisagras + ' bisagras (2 hasta 900 mm de alto, 3 hasta 1.600, 4 hasta 2.000)' },
      correderas: { base: cajones, detalle: cajones + (cajones === 1 ? ' cajón' : ' cajones') + ' → 1 par por cajón. Elige el largo según la profundidad del mueble.' },
      tiradores: { base: puertas + cajones, detalle: (puertas + cajones) + ' entre puertas y cajones → 1 tirador cada uno' },
      discos: { base: 1, detalle: 'Si aún no tienes un disco para tableros, estos son los de nuestra tienda para melamina y aglomerado. Revisa que el diámetro y el eje calcen con tu sierra.' },
      soportes: { base: repisas * 4, detalle: repisas + (repisas === 1 ? ' repisa' : ' repisas') + ' → 4 soportes cada una (para soportes tipo L o escuadra, ajusta la cantidad)' }
    };
  }

  function elegido(k) {
    // si el cliente aún no eligió nada en esa línea, se usa el producto sugerido (si hay uno razonable)
    var sel = estado.compra[k] ? estado.compra[k].id : (sugerido(k) || {}).id;
    return productos[k].filter(function (t) { return String(t.id) === String(sel) && t.disponible; })[0] || null;
  }

  // Producto sugerido por línea. Tapacanto, tiradores y disco no se sugieren: el tapacanto lo elige el cliente en el paso 3,
  // el tirador es gusto personal y el disco es opcional.
  function sugerido(k) {
    var lista = (productos[k] || []).filter(function (t) { return t.disponible && !/caja/i.test(t.nombre); });
    var buscar = function (pruebas) { return lista.filter(function (t) { return pruebas.every(function (r) { return r.test(t.nombre); }); })[0] || null; };
    if (k === 'bisagras') return buscar([/recta/i, /cierre suave/i, /par/i]);
    if (k === 'soportes') return buscar([/duplo/i, /niquelado/i]) || buscar([/duplo/i]);
    if (k === 'tornillos') return buscar([/chipboard 3,5 mm phillips/i, /40 mm$/]) || buscar([/chipboard/i, /40 mm/]);
    if (k === 'correderas') {
      // largo de la corredera = largo de los laterales de cajón (así los arma el generador de muebles)
      if (!ultimo) return null;
      var lat = ultimo.lista.filter(function (p) { return /lateral de caj/i.test(p.nombre); })[0];
      if (!lat) return null;
      var largo = Math.round(lat.fl);
      return buscar([/H45/, /zincad/i, new RegExp('\\b' + largo + ' mm'), /par/i]);
    }
    return null;
  }

  function cantidadSugerida(k, nec, prod) {
    if (!prod) return 0;
    return nec.base > 0 ? Math.max(1, Math.ceil(nec.base / prod.unidades)) : 0;
  }

  function cantidadFinal(k, nec, prod) {
    var c = estado.compra[k];
    var sug = cantidadSugerida(k, nec, prod);
    // si cambia lo sugerido (otra pieza u otro producto), se descarta la cantidad escrita a mano
    if (c && c.manual != null && c.sug === sug) return c.manual;
    return sug;
  }

  function opciones(k) {
    var grupos = {}, orden = [];
    productos[k].forEach(function (t) {
      var g = t.grupo || '';
      if (!grupos[g]) { grupos[g] = []; orden.push(g); }
      grupos[g].push(t);
    });
    var html = '<option value="">No agregar</option>';
    orden.forEach(function (g) {
      var ops = grupos[g].map(function (t) {
        return '<option value="' + t.id + '"' + (t.disponible ? '' : ' disabled') + '>' + esc(t.nombre) + ' · ' + dinero(t.precio) + (t.disponible ? '' : ' (sin stock)') + '</option>';
      }).join('');
      html += g ? '<optgroup label="' + esc(g) + '">' + ops + '</optgroup>' : ops;
    });
    return html;
  }

  function pintarCompra() {
    var cont = $('[data-compra]');
    if (!ultimo) { cont.innerHTML = ''; return; }
    var nec = necesidades(ultimo.lista);
    var filas = '', total = 0, hayAlgo = false, sinTipos = true;
    CONCEPTOS.forEach(function (c) {
      var n = nec[c.k];
      if (!(n.base > 0) || !productos[c.k].length) return;
      if (c.k === 'tapacanto' && estado.compra.tapacanto && estado.compra.tapacanto.id === 'no') return;
      if (c.k === 'tapacanto2' && !elegido('tapacanto2')) return;
      if (c.k !== 'tapacanto' && c.k !== 'tapacanto2' && c.k !== 'discos' && c.k !== 'tornillos') sinTipos = false;
      var prod = elegido(c.k);
      var cant = cantidadFinal(c.k, n, prod);
      var sub = prod ? prod.precio * cant : 0;
      total += sub;
      if (prod && cant > 0) hayAlgo = true;
      var esSugerido = prod && !estado.compra[c.k];
      var falta = !prod && c.k === 'tiradores' ? ' Elige un modelo para agregarlo.' : '';
      filas += '<div class="cc-item" data-item="' + c.k + '">' +
        '<div class="cc-item__info"><p class="cc-item__titulo">' + c.titulo + (esSugerido ? ' <span class="cc-sugerido">Sugerido</span>' : '') + '</p><p class="cc-nota">' + n.detalle + falta + (esSugerido ? ' Te sugerimos este modelo; puedes cambiarlo o elegir "No agregar".' : '') + '</p></div>' +
        campo('cc-c-' + c.k, 'Producto', '<select id="cc-c-' + c.k + '" data-prod>' + opciones(c.k) + '</select>') +
        campo('cc-q-' + c.k, 'Cantidad (' + c.venta[1] + ')', '<input id="cc-q-' + c.k + '" type="number" min="0" inputmode="numeric" data-cant value="' + cant + '"' + (prod ? '' : ' disabled') + '>') +
        '<p class="cc-item__sub">' + (prod ? dinero(sub) : '') + '</p>' +
        (prod ? '<a class="cc-enlace cc-item__ver" href="' + prod.url + '">Ver ficha</a>' : '') +
        '</div>';
    });
    var html = '<div class="cc-compra"><h2 class="cc-paso__titulo">Lista de compra</h2><p class="cc-nota cc-nota--intro">Lo que necesitas para este mueble según tus piezas. Puedes cambiar el producto o la cantidad de cada línea.</p>';
    html += filas || '';
    if (sinTipos) html += '<p class="cc-nota">Para calcular bisagras, correderas, tiradores y soportes, indica en cada pieza si es puerta, frente de cajón o repisa.</p>';
    html += '<div class="cc-compra__pie"><p class="cc-compra__total">Total: <strong>' + dinero(total) + '</strong></p>' +
      '<div class="cc-botones"><button type="button" class="button" data-carrito' + (hayAlgo ? '' : ' disabled') + '>Agregar todo al carrito</button></div></div>' +
      '<p class="cc-ok" data-ok hidden>Agregado al carrito. <a href="/cart">Ver carrito</a></p></div>';
    cont.innerHTML = html;

    cont.querySelectorAll('[data-item]').forEach(function (fila) {
      var k = fila.getAttribute('data-item');
      var sel = fila.querySelector('[data-prod]');
      var p = elegido(k);
      sel.value = p ? String(p.id) : '';
      sel.addEventListener('change', function () {
        estado.compra[k] = { id: sel.value || (k === 'tapacanto' ? 'no' : '') };
        if (k === 'tapacanto') { selTapa.value = estado.compra[k].id; calcular(true); return; }
        if (k === 'tapacanto2') { selTapa2.value = estado.compra[k].id; pintarPiezas(); calcular(true); return; }
        guardar(); pintarCompra();
      });
      fila.querySelector('[data-cant]').addEventListener('change', function (ev) {
        var prod = elegido(k);
        estado.compra[k] = { id: prod ? String(prod.id) : '', manual: Math.max(0, Math.round(num(ev.target.value))), sug: cantidadSugerida(k, nec[k], prod) };
        guardar(); pintarCompra();
      });
    });
    var btn = cont.querySelector('[data-carrito]');
    btn.addEventListener('click', function () {
      var items = itemsCompra();
      if (!items.length) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items.map(function (i) { return { id: i.prod.id, quantity: i.cant }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('carrito');
        cont.querySelector('[data-ok]').hidden = false;
        evento('carrito', { productos: items.length, unidades: items.reduce(function (t, i) { return t + i.cant; }, 0), valor: Math.round(items.reduce(function (t, i) { return t + i.prod.precio * i.cant; }, 0) / 100) });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function () {
        alert('No pudimos agregar todo al carrito. Puede que no haya stock suficiente de algún producto; revisa las cantidades o agrégalos desde su ficha.');
      }).finally(function () { btn.disabled = false; });
    });
    pintarCosto();
  }

  function itemsCompra() {
    if (!ultimo) return [];
    var nec = necesidades(ultimo.lista), items = [];
    CONCEPTOS.forEach(function (c) {
      var prod = elegido(c.k);
      if (!prod || !(nec[c.k].base > 0)) return;
      var cant = cantidadFinal(c.k, nec[c.k], prod);
      if (cant > 0) items.push({ c: c, prod: prod, cant: cant });
    });
    return items;
  }

  var ultimo = null; // último resultado, para el PDF, las etiquetas, el Excel y la lista de compra

  /* ---------- Cálculo por material ---------- */
  function calcular(forzar) {
    $('[data-validacion]').hidden = true;
    var kerf = Math.max(0, estado.kerf), o = Math.max(0, estado.refilado);
    var conCanto = estado.piezas.some(function (p) { return p.cantidad > 0 && ((p.cl || 0) + (p.ca || 0)) > 0; });
    var tapaId = estado.compra.tapacanto && estado.compra.tapacanto.id;
    if (conCanto && !tapaId) {
      selTapa.classList.add('cc-falta');
      $('[data-tapa-aviso]').hidden = false;
      selTapa.scrollIntoView({ behavior: 'smooth', block: 'center' });
      selTapa.focus();
      return;
    }
    var tapa = elegido('tapacanto'), tapa2 = elegido('tapacanto2');
    var espDe = function (p) {
      if (!estado.descontar) return 0;
      var t = tapa2 && p.tapa === 2 ? tapa2 : tapa;
      return t ? t.espesor : 0;
    };
    var esp = 0;
    var lista = [];
    estado.piezas.forEach(function (p, i) {
      var nombre = (p.nombre || '').trim() || 'Pieza ' + (i + 1);
      if (!(p.largo > 0 && p.ancho > 0 && p.cantidad > 0)) return;
      var e = (p.cl || p.ca) ? espDe(p) : 0;
      esp = Math.max(esp, e);
      for (var c = 0; c < Math.min(500, Math.round(p.cantidad)); c++) {
        // con canto en los lados largos se achica el ancho; con canto en los anchos, el largo
        lista.push({ n: i + 1, nombre: nombre, fl: p.largo, fa: p.ancho, largo: p.largo - (p.ca || 0) * e, ancho: p.ancho - (p.cl || 0) * e, girar: p.girar, cl: p.cl || 0, ca: p.ca || 0, tipo: p.tipo || 'pieza', mat: p.mat || 0, tapa: tapa2 && p.tapa === 2 ? 2 : 1 });
      }
    });
    if (!lista.length) { mostrarError('Agrega al menos una pieza con largo, ancho y cantidad.'); return; }
    var malo = estado.materiales.filter(function (m) { return !(m.largo - 2 * o > 0 && m.ancho - 2 * o > 0); })[0];
    if (malo) { mostrarError('Revisa la medida del tablero de "' + esc(nombreMaterial(estado.materiales.indexOf(malo))) + '".'); return; }

    // Medidas que suelen ser un error de tipeo: se avisan antes de calcular
    if (!forzar) {
      var avisos = [], validas = estado.piezas.filter(function (p) { return p.largo > 0 && p.ancho > 0 && p.cantidad > 0; });
      validas.forEach(function (p) {
        var i = estado.piezas.indexOf(p) + 1, n = (p.nombre || '').trim() || 'Pieza ' + i;
        var m = estado.materiales[p.mat || 0], W = m.largo - 2 * o, H = m.ancho - 2 * o;
        if (Math.min(p.largo, p.ancho) < 30) avisos.push('La pieza ' + i + ' (' + esc(n) + ') mide menos de 30 mm por un lado. Revisa que la medida esté bien.');
        var cabe = (p.largo <= W && p.ancho <= H) || (p.girar && p.ancho <= W && p.largo <= H);
        if (!cabe) avisos.push('La pieza ' + i + ' (' + esc(n) + ') es más grande que el tablero' + (!p.girar && p.ancho <= W && p.largo <= H ? ' en el sentido de la veta; marca "Se puede girar" si da lo mismo' : '') + '.');
      });
      if (estado.unidad === 'mm' && validas.length && validas.every(function (p) { return Math.max(p.largo, p.ancho) < 120; })) {
        avisos.unshift('Todas las piezas miden menos de 12 cm. ¿Las ingresaste en centímetros? Si es así, cambia la unidad a cm arriba de las piezas.');
      }
      if (avisos.length) {
        var v = $('[data-validacion]');
        v.querySelector('[data-validacion-lista]').innerHTML = avisos.map(function (a) { return '<li>' + a + '</li>'; }).join('');
        v.hidden = false;
        v.scrollIntoView({ behavior: 'smooth', block: 'center' });
        evento('aviso_medidas', { avisos: avisos.length });
        return;
      }
    }

    // El cálculo puede tardar uno o dos segundos con muchas piezas: primero se muestra el aviso
    ocupado(true);
    setTimeout(function () {
      try { calcularPlanes(lista, esp, kerf, o); } finally { ocupado(false); }
    }, 40);
  }

  function ocupado(si) {
    raiz.classList.toggle('calc-c--calculando', si);
    raiz.querySelectorAll('[data-calcular], [data-barra] button, [data-validacion-seguir]').forEach(function (b) {
      if (!b.dataset.texto) b.dataset.texto = b.textContent;
      b.disabled = si;
      b.textContent = si ? 'Calculando…' : b.dataset.texto;
    });
  }

  function calcularPlanes(lista, esp, kerf, o) {
    var grupos = [];
    estado.materiales.forEach(function (m, mi) {
      var sub = lista.filter(function (p) { return p.mat === mi; });
      if (!sub.length) return;
      var W = m.largo - 2 * o, H = m.ancho - 2 * o;
      var retazos = [];
      (m.retazos || []).forEach(function (r) {
        if (!(r.largo > 0 && r.ancho > 0)) return;
        var l = Math.max(r.largo, r.ancho), a = Math.min(r.largo, r.ancho);
        for (var c = 0; c < Math.min(50, Math.max(1, Math.round(r.cantidad || 1))); c++) retazos.push({ w: l, h: a });
      });
      var r = optimizar(sub, W, H, kerf, retazos);
      // medidas para dibujar: tablero completo con su borde a recortar; los retazos se dibujan tal cual
      r.tableros.forEach(function (t) {
        if (t.retazo) { t.L = t.W; t.A = t.H; t.o = 0; } else { t.L = m.largo; t.A = m.ancho; t.o = o; }
        t.mat = mi;
      });
      grupos.push({ mat: mi, r: r, lista: sub });
    });
    mostrar(grupos, lista, esp);
    var c = ultimo.c;
    evento('calcular', { tableros: c.nuevos, retazos: c.retazos, materiales: grupos.length, piezas: lista.length, tipos: estado.piezas.length, unidad: estado.unidad, ejemplo: !!estado.ejemplo, minimo: c.esMinimo });
  }

  function mostrarError(t) {
    ultimo = null;
    $('[data-resultado]').hidden = false;
    $('[data-resumen]').innerHTML = '<p class="cc-aviso">' + t + '</p>';
    $('[data-planos]').innerHTML = '';
    $('[data-compra]').innerHTML = '';
    $('[data-costo]').innerHTML = '';
  }

  /* ---------- Resultado ---------- */
  function cifras(grupos, lista) {
    var areaPiezas = 0, areaUsada = 0, nuevos = 0, retazos = 0, noCaben = 0, esMinimo = true;
    grupos.forEach(function (g) {
      g.r.tableros.forEach(function (t) {
        if (t.retazo) retazos++; else nuevos++;
        areaUsada += t.L * t.A;
        t.puestas.forEach(function (q) { areaPiezas += q.w * q.h; });
      });
      noCaben += g.r.noCaben.length;
      if (g.r.minimo == null || g.r.nuevos !== g.r.minimo || g.r.noCaben.length) esMinimo = false;
    });
    return {
      nuevos: nuevos, retazos: retazos, noCaben: noCaben, esMinimo: esMinimo,
      aprov: areaUsada ? areaPiezas / areaUsada * 100 : 0,
      piezas: lista.length - noCaben,
      sobrante: (areaUsada - areaPiezas) / 1e6
    };
  }

  function textoTablero(m) {
    return 'Tablero de ' + fmt(m.largo) + ' × ' + fmt(m.ancho) + ' mm, espesor de corte de ' + fmt(estado.kerf, 1) + ' mm' +
      (estado.refilado > 0 ? ' y ' + fmt(estado.refilado) + ' mm de borde recortado por lado' : '') + '.';
  }
  function tituloTablero(t, k, total) {
    return (t.retazo ? 'Retazo ' + fmt(t.L) + ' × ' + fmt(t.A) + ' mm' : 'Tablero ' + k + ' de ' + total) + ' · ' + fmt(t.puestas.reduce(function (s, q) { return s + q.w * q.h; }, 0) / (t.L * t.A) * 100, 1) + ' % aprovechado';
  }
  function cifra(v, t) { return '<div class="cc-cifra"><strong>' + v + '</strong><span>' + t + '</span></div>'; }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

  function mostrar(grupos, lista, esp) {
    var c = cifras(grupos, lista);
    ultimo = { grupos: grupos, lista: lista, c: c, esp: esp };
    $('[data-resultado]').hidden = false;
    var varios = grupos.length > 1;

    var html = '<div class="cc-cifras">' +
      cifra(fmt(c.nuevos), c.nuevos === 1 ? 'tablero nuevo' : 'tableros nuevos') +
      (c.retazos ? cifra(fmt(c.retazos), c.retazos === 1 ? 'retazo usado' : 'retazos usados') : '') +
      cifra(fmt(c.aprov, 1) + ' %', 'aprovechamiento') +
      cifra(fmt(c.piezas), 'piezas') +
      (c.retazos ? '' : cifra(fmt(c.sobrante, 2) + ' m²', 'sobrante')) +
      '</div>';
    if (varios) html += '<p class="cc-nota">' + grupos.map(function (g) { var n = g.r.nuevos; return '<strong>' + esc(nombreMaterial(g.mat)) + ':</strong> ' + n + (n === 1 ? ' tablero' : ' tableros') + (g.r.tableros.length > n ? ' + ' + (g.r.tableros.length - n) + ' retazo(s)' : ''); }).join(' · ') + '</p>';
    else html += '<p class="cc-nota">' + textoTablero(estado.materiales[grupos[0].mat]) + ' Cortes de lado a lado, aptos para sierra escuadradora o circular.</p>';
    html += '<p class="cc-nota">El número en cada pieza del plano es el de la pieza en el paso 2.</p>';
    if (c.esMinimo) html += '<p class="cc-nota"><strong>Es el mínimo posible: tus piezas no caben en menos tableros.</strong></p>';
    if (esp) html += '<p class="cc-nota">' + (elegido('tapacanto2') ? 'Medidas de corte con el espesor de cada tapacanto descontado' : 'Medidas de corte con ' + fmt(esp, 1) + ' mm descontados') + ' por cada lado con canto. Al pegar el canto, las piezas quedan con las medidas que ingresaste.</p>';
    grupos.forEach(function (g) {
      if (!g.r.noCaben.length) return;
      html += '<p class="cc-aviso">' + g.r.noCaben.length + ' pieza(s) no caben en el tablero' + (varios ? ' de ' + esc(nombreMaterial(g.mat)) : '') + ': ' + esc(uniq(g.r.noCaben.map(function (p) { return p.nombre + ' (' + fmt(p.largo) + ' × ' + fmt(p.ancho) + ')'; })).join(', ')) + '. Revisa sus medidas o marca "Se puede girar".</p>';
    });
    $('[data-resumen]').innerHTML = html;

    $('[data-planos]').innerHTML = grupos.map(function (g) {
      var nuevosG = g.r.tableros.filter(function (t) { return !t.retazo; }).length, k = 0;
      return (varios ? '<h3 class="cc-material-titulo">' + esc(nombreMaterial(g.mat)) + '</h3>' : '') + '<div class="cc-planos__grilla">' +
        g.r.tableros.map(function (t) {
          if (!t.retazo) k++;
          return '<div class="cc-plano"><p class="cc-plano__titulo">' + tituloTablero(t, k, nuevosG) + '</p>' + svg(t) + tablaTablero(t) + secuencia(t) + '</div>';
        }).join('') + '</div>';
    }).join('');
    pintarCompra();
    $('[data-resultado]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Plano del tablero. El texto se ajusta al tamaño de cada pieza; si no cabe, se muestra solo el número.
  function svg(t) {
    var L = t.L, A = t.A, o = t.o;
    var s = '<svg class="cc-svg" viewBox="0 0 ' + L + ' ' + A + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Plan de corte">' +
      '<rect x="0" y="0" width="' + L + '" height="' + A + '" fill="#EEEEEE" stroke="#000" stroke-width="' + Math.max(2, L / 600) + '"/>';
    var sw = Math.max(1.5, L / 800);
    t.puestas.forEach(function (q) {
      var x = q.x + o, y = q.y + o, cx = x + q.w / 2, cy = y + q.h / 2;
      s += '<rect x="' + x + '" y="' + y + '" width="' + q.w + '" height="' + q.h + '" fill="#fff" stroke="#000" stroke-width="' + sw + '" class="cc-svg__pieza"/>';
      var medida = fmt(q.w) + ' × ' + fmt(q.h);
      var titulo = q.n + '. ' + q.nombre;
      var largoTxt = Math.max(titulo.length, medida.length);
      var base = L / 2440;
      var fs = Math.min(q.h / 3.4, (q.w * 0.9) / (largoTxt * 0.58), 90 * base);
      if (fs >= 34 * base) {
        s += '<text x="' + cx + '" y="' + (cy - fs * 0.15) + '" font-size="' + fs + '" text-anchor="middle" font-family="Inter, Arial, sans-serif" font-weight="700" fill="#000">' + esc(titulo) + '</text>' +
          '<text x="' + cx + '" y="' + (cy + fs * 1.0) + '" font-size="' + fs * 0.85 + '" text-anchor="middle" font-family="Inter, Arial, sans-serif" fill="#333">' + medida + '</text>';
      } else {
        var fn = Math.min(q.h * 0.6, q.w * 0.6 / String(q.n).length, 70 * base);
        if (fn >= 14 * base) s += '<text x="' + cx + '" y="' + (cy + fn * 0.35) + '" font-size="' + fn + '" text-anchor="middle" font-family="Inter, Arial, sans-serif" font-weight="700" fill="#000">' + q.n + '</text>';
      }
    });
    return s + '</svg>';
  }

  // Orden de corte de un tablero: franjas, luego columnas, luego piezas apiladas
  function secuencia(t) {
    if (!t.franjas) return '';
    var dir = t.modo === 'h' ? 'a lo largo' : 'a lo ancho';
    var corte = fmt(t.modo === 'h' ? t.L : t.A);
    var mm = function (v) { return fmt(v, 1).replace(/,0$/, '') + ' mm'; };
    var li = t.franjas.map(function (f, i) {
      var partes = f.cols.map(function (col) {
        var ps = col.piezas;
        var nums = ps.map(function (q) { return q.p.n; });
        if (ps.length === 1 && Math.abs(ps[0].h - f.h) < 0.05) return mm(col.w) + ' (pieza ' + nums[0] + ')';
        if (ps.length === 1) return mm(col.w) + ' y recórtalo a ' + mm(ps[0].h) + ' (pieza ' + nums[0] + ')';
        return mm(col.w) + ' y divídelo en ' + ps.map(function (q) { return mm(q.h); }).join(' + ') + ' (piezas ' + nums.join(', ') + ')';
      });
      var agrupadas = [];
      partes.forEach(function (p) {
        var u = agrupadas[agrupadas.length - 1];
        if (u && u.t === p) u.n++; else agrupadas.push({ t: p, n: 1 });
      });
      partes = agrupadas.map(function (g) { return g.n > 1 ? g.n + ' × ' + g.t : g.t; });
      var sobra = t.BW - f.largoUsado;
      return '<li><strong>Franja ' + (i + 1) + ' de ' + mm(f.h) + '</strong>, cortando ' + dir + ' del ' + (t.retazo ? 'retazo' : 'tablero') + ' (' + corte + ' mm). Luego córtala en ' + partes.join(' · ') + (sobra > 1 ? ' · sobran ' + mm(Math.max(0, sobra - estado.kerf)) : '') + '.</li>';
    }).join('');
    var resto = t.BH - t.alto - estado.kerf;
    if (resto > 1) li += '<li>Sobra una franja de ' + mm(resto) + '.</li>';
    return '<div class="cc-secuencia"><p class="cc-secuencia__titulo">Orden de corte</p><ol>' + li + '</ol></div>';
  }

  function medida(l, a) { return fmt(l, 1).replace(/,0$/, '') + ' × ' + fmt(a, 1).replace(/,0$/, '') + ' mm'; }

  function gruposDe(puestas) {
    var grupos = {}, orden = [];
    puestas.forEach(function (q) {
      var k = q.n;
      if (!grupos[k]) { grupos[k] = { n: q.n, nombre: q.nombre, largo: q.largo, ancho: q.ancho, fl: q.fl, fa: q.fa, cl: q.cl, ca: q.ca, mat: q.mat, cant: 0 }; orden.push(k); }
      grupos[k].cant++;
    });
    return orden.sort(function (a, b) { return a - b; }).map(function (k) { return grupos[k]; });
  }

  function tablaTablero(t) {
    var f = gruposDe(t.puestas).map(function (g) {
      return '<tr><td>' + g.n + '</td><td>' + esc(g.nombre) + '</td><td>' + medida(g.largo, g.ancho) + '</td>' + (ultimo && ultimo.esp ? '<td>' + medida(g.fl, g.fa) + '</td>' : '') + '<td>' + g.cant + '</td></tr>';
    }).join('');
    var cab = ultimo && ultimo.esp ? '<th>Corte</th><th>Final con canto</th>' : '<th>Medida</th>';
    return '<table class="cc-tabla"><thead><tr><th>N°</th><th>Pieza</th>' + cab + '<th>Cant.</th></tr></thead><tbody>' + f + '</tbody></table>';
  }

  function todasLasPuestas() {
    var out = [];
    if (!ultimo) return out;
    ultimo.grupos.forEach(function (g) {
      var k = 0;
      g.r.tableros.forEach(function (t) {
        if (!t.retazo) k++;
        t.puestas.forEach(function (q) { out.push({ q: q, t: t, tablero: t.retazo ? 'Retazo' : 'Tablero ' + k, mat: g.mat }); });
      });
    });
    return out;
  }

  /* ---------- Costo del proyecto ---------- */
  function costo() {
    if (!ultimo) return null;
    var filas = [], total = 0, faltaPrecio = false;
    ultimo.grupos.forEach(function (g) {
      var m = estado.materiales[g.mat], n = g.r.nuevos;
      if (m.precio > 0) { filas.push({ t: nombreMaterial(g.mat) + ': ' + n + (n === 1 ? ' tablero' : ' tableros') + ' × ' + pesos(m.precio), v: n * m.precio }); total += n * m.precio; }
      else faltaPrecio = true;
    });
    var items = itemsCompra(), tienda = items.reduce(function (t, i) { return t + i.prod.precio * i.cant; }, 0) / 100;
    if (tienda) { filas.push({ t: 'Productos de la lista de compra (Toolstore)', v: tienda }); total += tienda; }
    return { filas: filas, total: total, faltaPrecio: faltaPrecio };
  }

  function pintarCosto() {
    var cont = $('[data-costo]');
    var c = costo();
    if (!c || !c.filas.length) {
      cont.innerHTML = ultimo ? '<div class="cc-costo"><h2 class="cc-paso__titulo">Costo del mueble</h2><p class="cc-nota">Ingresa el precio por tablero en el paso 1 y elige productos en la lista de compra para ver el costo total del proyecto.</p></div>' : '';
      return;
    }
    cont.innerHTML = '<div class="cc-costo"><h2 class="cc-paso__titulo">Costo del mueble</h2><table class="cc-tabla cc-tabla--costo"><tbody>' +
      c.filas.map(function (f) { return '<tr><td>' + esc(f.t) + '</td><td>' + pesos(f.v) + '</td></tr>'; }).join('') +
      '<tr class="cc-tabla__total"><td>Total estimado</td><td>' + pesos(c.total) + '</td></tr></tbody></table>' +
      (c.faltaPrecio ? '<p class="cc-nota">Falta el precio de algún material; agrégalo en el paso 1 para que el total lo incluya.</p>' : '') +
      '<p class="cc-nota">El precio de los tableros es el que ingresaste. Los productos Toolstore van con el precio de hoy.</p></div>';
  }

  /* ---------- PDF: documento aparte, limpio, listo para imprimir o guardar ---------- */
  var ESTILO_DOC = '@page{size:A4;margin:14mm}*{box-sizing:border-box}body{font-family:Inter,Arial,sans-serif;color:#000;margin:0;font-size:11px;line-height:1.4}' +
    'header{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid #000;padding-bottom:8px;margin-bottom:14px}' +
    '.logo{font-size:22px;font-weight:700;letter-spacing:.02em}.fecha{font-size:11px;color:#333;text-align:right}' +
    'h1{font-size:16px;font-weight:400;text-transform:uppercase;margin:0 0 4px}h2{font-size:13px;font-weight:700;text-transform:uppercase;margin:18px 0 8px}h3{font-size:11px;font-weight:700;text-transform:uppercase;margin:0 0 6px}' +
    '.cifras{display:flex;gap:8px;margin:10px 0}.cifras div{flex:1;background:#F9F9F9;padding:8px 10px}.cifras strong{display:block;font-size:16px}.cifras span{font-size:9px;text-transform:uppercase;color:#333}' +
    'table{width:100%;border-collapse:collapse;margin-top:6px}th{border-bottom:1px solid #CCC;padding:4px;text-align:center;font-size:10px;text-transform:uppercase}td{border-bottom:1px solid #EEE;padding:4px;text-align:center}' +
    '.plano{break-inside:avoid;page-break-inside:avoid;margin-top:16px}svg{width:100%;height:auto;display:block}' +
    '.nota{color:#333;font-size:10px;margin:6px 0 0}.aviso{border:1px solid #000;padding:6px 8px}.bloque{break-inside:avoid;page-break-inside:avoid}' +
    '.secuencia{margin-top:8px}.secuencia__titulo{font-weight:700;text-transform:uppercase;margin:0 0 4px}.secuencia ol{margin:0;padding-left:18px}.secuencia li{margin-bottom:2px}' +
    '.total td{font-weight:700;border-top:1px solid #000}' +
    'footer{margin-top:18px;border-top:1px solid #CCC;padding-top:6px;font-size:9px;color:#333}';

  function abrirDocumento(titulo, cuerpo, estilo) {
    var doc = '<!doctype html><html lang="es"><head><meta charset="utf-8"><title>' + esc(titulo) + '</title><style>' + estilo + '</style></head><body>' + cuerpo +
      '<script>window.onload=function(){setTimeout(function(){window.print();},300);};<\/script></body></html>';
    var w = window.open('', '_blank');
    if (!w) { alert('Tu navegador bloqueó la ventana. Permite las ventanas emergentes para toolstore.cl e intenta de nuevo.'); return false; }
    w.document.open(); w.document.write(doc); w.document.close();
    return true;
  }
  var hoy = function () { return new Date().toLocaleDateString('es-CL', { day: 'numeric', month: 'long', year: 'numeric' }); };
  var nombreProyecto = function () { return estado.proyecto.nombre.trim(); };

  function tablaCazoletas() {
    var puertas = gruposDe(todasLasPuestas().map(function (x) { return x.q; })).filter(function (g) { return esPuerta(g); });
    if (!puertas.length) return '';
    return '<section class="bloque"><h2>Perforaciones de bisagras</h2><table><thead><tr><th>N°</th><th>Puerta</th><th>Alto</th><th>Bisagras</th><th>Centro de cada cazoleta, desde abajo</th></tr></thead><tbody>' +
      puertas.map(function (g) { return '<tr><td>' + g.n + '</td><td>' + esc(g.nombre) + '</td><td>' + fmt(g.fl) + ' mm</td><td>' + bisagrasPorPuerta(g.fl) + '</td><td>' + textoCazoletas(g.fl) + '</td></tr>'; }).join('') +
      '</tbody></table><p class="nota">Cazoleta de 35 mm con el centro a 22,5 mm del canto de la puerta, la habitual en bisagras de cazoleta. Confirma con la ficha de tu bisagra antes de perforar.</p></section>';
  }

  function pdf() {
    if (!ultimo) return;
    var c = ultimo.c, esp = ultimo.esp;
    var piezas = gruposDe(todasLasPuestas().map(function (x) { return x.q; })).map(function (g) {
      var canto = (g.cl || g.ca) ? (g.cl || 0) + ' largo / ' + (g.ca || 0) + ' corto' : '-';
      return '<tr><td>' + g.n + '</td><td>' + esc(g.nombre) + '</td>' + (ultimo.grupos.length > 1 ? '<td>' + esc(nombreMaterial(g.mat)) + '</td>' : '') + '<td>' + medida(g.largo, g.ancho) + '</td>' + (esp ? '<td>' + medida(g.fl, g.fa) + '</td>' : '') + '<td>' + g.cant + '</td><td>' + canto + '</td></tr>';
    }).join('');
    var planos = ultimo.grupos.map(function (g) {
      var nuevosG = g.r.nuevos, k = 0;
      return (ultimo.grupos.length > 1 ? '<h2>' + esc(nombreMaterial(g.mat)) + '</h2>' : '') + g.r.tableros.map(function (t) {
        if (!t.retazo) k++;
        return '<section class="plano"><h3>' + tituloTablero(t, k, nuevosG) + '</h3>' + svg(t) + tablaTablero(t).replace(' class="cc-tabla"', '') + secuencia(t).replace(/ class="cc-secuencia(__titulo)?"/g, ' class="secuencia$1"') + '</section>';
      }).join('');
    }).join('');
    var compra = itemsCompra();
    var tablaCompra = compra.length ? '<section class="bloque"><h2>Lista de compra</h2><table><thead><tr><th>Producto</th><th>Cantidad</th><th>Subtotal</th></tr></thead><tbody>' +
      compra.map(function (i) { return '<tr><td>' + esc(i.prod.nombre) + '</td><td>' + i.cant + ' ' + (i.cant === 1 ? i.c.venta[0] : i.c.venta[1]) + '</td><td>' + dinero(i.prod.precio * i.cant) + '</td></tr>'; }).join('') +
      '</tbody></table><p class="nota">Precios de toolstore.cl al ' + hoy() + ', sujetos a stock.</p></section>' : '';
    var co = costo();
    var tablaCosto = co && co.filas.length ? '<section class="bloque"><h2>Costo estimado</h2><table><tbody>' + co.filas.map(function (f) { return '<tr><td style="text-align:left">' + esc(f.t) + '</td><td>' + pesos(f.v) + '</td></tr>'; }).join('') +
      '<tr class="total"><td style="text-align:left">Total estimado</td><td>' + pesos(co.total) + '</td></tr></tbody></table></section>' : '';
    var noCaben = c.noCaben ? '<p class="aviso">' + c.noCaben + ' pieza(s) no caben en el tablero y no aparecen en el plan.</p>' : '';
    var materiales = ultimo.grupos.map(function (g) { var m = estado.materiales[g.mat]; return esc(nombreMaterial(g.mat)) + ': ' + fmt(m.largo) + ' × ' + fmt(m.ancho) + ' mm'; }).join(' · ');
    var pj = nombreProyecto(), cli = estado.proyecto.cliente.trim();

    var cuerpo = '<header><div><div class="logo">TOOLSTORE</div><h1>Plan de corte' + (pj ? ' · ' + esc(pj) : '') + '</h1>' + (cli ? '<div>Cliente: ' + esc(cli) + '</div>' : '') + '</div><div class="fecha">' + hoy() + '<br>toolstore.cl</div></header>' +
      '<p>' + materiales + '. Espesor de corte ' + fmt(estado.kerf, 1) + ' mm' + (estado.refilado > 0 ? ', borde recortado ' + fmt(estado.refilado) + ' mm por lado' : '') + '. Cortes de lado a lado, aptos para sierra escuadradora o circular.</p>' +
      '<div class="cifras"><div><strong>' + fmt(c.nuevos) + '</strong><span>' + (c.nuevos === 1 ? 'tablero nuevo' : 'tableros nuevos') + '</span></div>' + (c.retazos ? '<div><strong>' + c.retazos + '</strong><span>retazos usados</span></div>' : '') +
      '<div><strong>' + fmt(c.aprov, 1) + ' %</strong><span>aprovechamiento</span></div><div><strong>' + fmt(c.piezas) + '</strong><span>piezas</span></div></div>' +
      noCaben +
      '<section class="bloque"><h2>Lista de piezas</h2><table><thead><tr><th>N°</th><th>Pieza</th>' + (ultimo.grupos.length > 1 ? '<th>Material</th>' : '') + (esp ? '<th>Corte</th><th>Final con canto</th>' : '<th>Medida</th>') + '<th>Cant.</th><th>Tapacanto</th></tr></thead><tbody>' + piezas + '</tbody></table>' +
      (esp ? '<p class="nota">Medidas de corte con ' + fmt(esp, 1) + ' mm descontados por cada lado con tapacanto.</p>' : '') + '</section>' +
      tablaCompra + tablaCosto + tablaCazoletas() +
      '<h2>Planos</h2>' + planos +
      '<footer>Generado con la calculadora de cortes de toolstore.cl. Verifica las medidas antes de cortar.</footer>';
    abrirDocumento('Plan de corte' + (pj ? ' - ' + pj : '') + ' - Toolstore', cuerpo, ESTILO_DOC);
  }

  /* ---------- Perforaciones de bisagra para puertas ---------- */
  // Cazoleta de 35 mm con el centro a 22,5 mm del canto de la puerta. La primera y la última a 100 mm de los extremos; las demás, repartidas.
  function cazoletas(alto) {
    var n = bisagrasPorPuerta(alto), pos = [100];
    for (var i = 1; i < n - 1; i++) pos.push(Math.round(100 + (alto - 200) * i / (n - 1)));
    pos.push(Math.round(alto - 100));
    return pos;
  }
  var textoCazoletas = function (alto) { return cazoletas(alto).map(function (v) { return fmt(v); }).join(' · ') + ' mm'; };

  /* ---------- Etiquetas: una por pieza, hoja A4 de 3 × 8 (70 × 37 mm) ---------- */
  function cantoSvg(cl, ca) {
    // rectángulo de la pieza: los lados con tapacanto van marcados con línea gruesa
    var g = function (on) { return on ? 'stroke="#000" stroke-width="3"' : 'stroke="#999" stroke-width="1" stroke-dasharray="2 2"'; };
    return '<svg viewBox="0 0 60 34" width="60" height="34" xmlns="http://www.w3.org/2000/svg">' +
      '<line x1="4" y1="30" x2="56" y2="30" ' + g(cl >= 1) + '/><line x1="4" y1="4" x2="56" y2="4" ' + g(cl >= 2) + '/>' +
      '<line x1="4" y1="4" x2="4" y2="30" ' + g(ca >= 1) + '/><line x1="56" y1="4" x2="56" y2="30" ' + g(ca >= 2) + '/></svg>';
  }
  var esPuerta = function (q) { var p = estado.piezas[q.n - 1]; return p && p.tipo === 'puerta'; };
  function etiquetas() {
    var todas = todasLasPuestas().sort(function (a, b) { return a.q.n - b.q.n; });
    if (!todas.length) return;
    var pj = nombreProyecto();
    var cuerpo = '<div class="hoja">' + todas.map(function (x) {
      var q = x.q;
      return '<div class="et"><div class="et__top"><span>' + esc(pj || 'Toolstore') + '</span><span>' + esc(x.tablero) + '</span></div>' +
        '<div class="et__n">' + q.n + '. ' + esc(q.nombre) + '</div>' +
        '<div class="et__fila"><div><div class="et__med">' + medida(q.fl, q.fa) + '</div>' +
        (ultimo.esp ? '<div class="et__sub">Corte ' + medida(q.largo, q.ancho) + '</div>' : '') +
        (ultimo.grupos.length > 1 ? '<div class="et__sub">' + esc(nombreMaterial(x.mat)) + '</div>' : '') +
        (esPuerta(q) ? '<div class="et__sub">Cazoletas Ø35 a 22,5 mm del canto: ' + textoCazoletas(q.fl) + '</div>' : '') + '</div>' +
        '<div class="et__canto">' + cantoSvg(q.cl, q.ca) + '<span>Canto</span></div></div></div>';
    }).join('') + '</div>';
    var estilo = '@page{size:A4;margin:12mm 0 0 0}*{box-sizing:border-box}body{margin:0;font-family:Inter,Arial,sans-serif;color:#000}' +
      '.hoja{display:grid;grid-template-columns:repeat(3,70mm);grid-auto-rows:37mm;width:210mm}' +
      '.et{padding:3mm 4mm;overflow:hidden;border:0.2mm dashed #ddd;break-inside:avoid;page-break-inside:avoid;display:flex;flex-direction:column;gap:1mm}' +
      '.et__top{display:flex;justify-content:space-between;font-size:7pt;color:#333;text-transform:uppercase}' +
      '.et__n{font-size:10pt;font-weight:700;line-height:1.15;max-height:2.3em;overflow:hidden}' +
      '.et__fila{display:flex;justify-content:space-between;align-items:flex-end;margin-top:auto}' +
      '.et__med{font-size:11pt;font-weight:700}.et__sub{font-size:7pt;color:#333}' +
      '.et__canto{display:flex;flex-direction:column;align-items:center;font-size:6pt;color:#333}';
    if (abrirDocumento('Etiquetas' + (pj ? ' - ' + pj : '') + ' - Toolstore', cuerpo, estilo)) evento('etiquetas', { etiquetas: todas.length });
  }

  /* ---------- Excel (CSV con punto y coma, como lo abre Excel en Chile) ---------- */
  function excel() {
    if (!ultimo) return;
    var dec = function (v) { return String(Math.round(v * 10) / 10).replace('.', ','); };
    var filas = [['N°', 'Pieza', 'Material', 'Largo final (mm)', 'Ancho final (mm)', 'Largo corte (mm)', 'Ancho corte (mm)', 'Cantidad', 'Respeta veta', 'Canto lados largos', 'Canto lados cortos', 'Tipo']];
    var grupos = {}, orden = [];
    ultimo.lista.forEach(function (p) {
      var k = p.n;
      if (!grupos[k]) { grupos[k] = { p: p, cant: 0 }; orden.push(k); }
      grupos[k].cant++;
    });
    orden.sort(function (a, b) { return a - b; }).forEach(function (k) {
      var g = grupos[k], p = g.p;
      filas.push([p.n, p.nombre, nombreMaterial(p.mat), dec(p.fl), dec(p.fa), dec(p.largo), dec(p.ancho), g.cant, p.girar ? 'No' : 'Sí', p.cl, p.ca, (TIPOS.filter(function (t) { return t[0] === p.tipo; })[0] || TIPOS[0])[1]]);
    });
    var csv = '﻿' + filas.map(function (f) { return f.map(function (c) { c = String(c); return /[;"\n]/.test(c) ? '"' + c.replace(/"/g, '""') + '"' : c; }).join(';'); }).join('\r\n');
    descargar(csv, 'text/csv;charset=utf-8', (nombreArchivo() || 'lista-de-corte') + '-toolstore.csv');
    evento('excel', { piezas: ultimo.lista.length });
  }
  var nombreArchivo = function () { return nombreProyecto().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
  function descargar(texto, tipo, nombre) {
    var blob = new Blob([texto], { type: tipo });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = nombre;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
  }

  /* ---------- DXF: planos para CNC o software de corte (milímetros, un tablero al lado del otro) ---------- */
  function dxf() {
    if (!ultimo) return;
    var out = ['0', 'SECTION', '2', 'HEADER', '9', '$ACADVER', '1', 'AC1009', '9', '$INSUNITS', '70', '4', '0', 'ENDSEC',
      '0', 'SECTION', '2', 'TABLES', '0', 'TABLE', '2', 'LAYER', '70', '3'];
    [['TABLERO', 7], ['PIEZAS', 5], ['TEXTO', 3]].forEach(function (c) { out.push('0', 'LAYER', '2', c[0], '70', '0', '62', String(c[1]), '6', 'CONTINUOUS'); });
    out.push('0', 'ENDTAB', '0', 'ENDSEC', '0', 'SECTION', '2', 'ENTITIES');
    var n = function (v) { return String(Math.round(v * 100) / 100); };
    var rect = function (capa, x, y, w, h) {
      out.push('0', 'POLYLINE', '8', capa, '66', '1', '70', '1', '10', '0', '20', '0', '30', '0');
      [[x, y], [x + w, y], [x + w, y + h], [x, y + h]].forEach(function (v) { out.push('0', 'VERTEX', '8', capa, '10', n(v[0]), '20', n(v[1]), '30', '0'); });
      out.push('0', 'SEQEND', '8', capa);
    };
    var texto = function (x, y, alto, t) {
      out.push('0', 'TEXT', '8', 'TEXTO', '10', n(x), '20', n(y), '30', '0', '40', n(alto), '1', t, '72', '1', '11', n(x), '21', n(y), '31', '0');
    };
    // sin tildes ni ñ en los textos: algunos programas de CNC leen el DXF en ASCII
    var ascii = function (t) { return String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^\x20-\x7E]/g, ''); };
    var ox = 0, oy = 0;
    ultimo.grupos.forEach(function (g) {
      var k = 0, alto = 0; ox = 0;
      g.r.tableros.forEach(function (t) {
        if (!t.retazo) k++;
        var L = t.L, A = t.A, o = t.o;
        rect('TABLERO', ox, oy, L, A);
        texto(ox + L / 2, oy + A + 60, 50, ascii(nombreMaterial(g.mat) + ' - ' + (t.retazo ? 'RETAZO' : 'TABLERO ' + k) + ' - ' + L + ' x ' + A + ' mm - disco ' + n(estado.kerf) + ' mm'));
        t.puestas.forEach(function (q) {
          // el plano en pantalla tiene el origen arriba; en DXF el eje Y sube
          var x = ox + q.x + o, y = oy + A - (q.y + o) - q.h;
          rect('PIEZAS', x, y, q.w, q.h);
          var a = Math.min(q.h / 5, q.w / 10, 40);
          if (a >= 8) {
            texto(x + q.w / 2, y + q.h / 2 + a * 0.7, a, ascii(q.n + '. ' + q.nombre));
            texto(x + q.w / 2, y + q.h / 2 - a * 0.9, a * 0.8, n(q.w) + ' x ' + n(q.h));
          }
        });
        ox += L + 200; alto = Math.max(alto, A);
      });
      oy -= alto + 400;
    });
    out.push('0', 'ENDSEC', '0', 'EOF');
    descargar(out.join('\r\n') + '\r\n', 'application/dxf', (nombreArchivo() || 'plan-de-corte') + '-toolstore.dxf');
  }

  /* ---------- Enlace para compartir: el plan viaja en la dirección, sin guardar nada en el servidor ---------- */
  function enlace() {
    var c = {};
    Object.keys(estado.compra).forEach(function (k) { if (estado.compra[k] && estado.compra[k].id) c[k] = estado.compra[k].id; });
    var d = {
      v: 5, k: estado.kerf, r: estado.refilado, m: estado.merma, d: estado.descontar ? 1 : 0, u: estado.unidad, c: c,
      pj: [estado.proyecto.nombre, estado.proyecto.cliente],
      mt: estado.materiales.map(function (m) { return [m.nombre, m.largo, m.ancho, m.tablero, m.precio, (m.retazos || []).map(function (r) { return [r.largo, r.ancho, r.cantidad]; })]; }),
      p: estado.piezas.map(function (p) {
        var ti = 0;
        TIPOS.forEach(function (t, i) { if (t[0] === p.tipo) ti = i; });
        return [p.nombre || '', p.largo, p.ancho, p.cantidad, p.girar ? 1 : 0, p.cl || 0, p.ca || 0, ti, p.mat || 0];
      })
    };
    var b = btoa(unescape(encodeURIComponent(JSON.stringify(d)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return location.origin + location.pathname + '#plan=' + b;
  }

  function avisar(t) {
    var el = $('[data-compartir-ok]');
    el.textContent = t; el.hidden = false;
    clearTimeout(avisar.t); avisar.t = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Pegar piezas desde Excel ---------- */
  // Acepta filas con: nombre, largo, ancho, cantidad (separadas por tabulación, punto y coma o coma). La primera fila puede ser de títulos.
  function leerPegado(texto) {
    var filas = String(texto || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    var piezas = [];
    filas.forEach(function (l) {
      var c = l.indexOf('\t') >= 0 ? l.split('\t') : l.indexOf(';') >= 0 ? l.split(';') : l.split(',');
      c = c.map(function (x) { return x.trim(); });
      var nums = [], nombre = '';
      c.forEach(function (x) {
        var v = x.replace(/\s*(mm|cm)$/i, '');
        if (/^\d+([.,]\d+)?$/.test(v)) nums.push(num(v)); else if (!nombre && x) nombre = x;
      });
      if (nums.length < 2) return; // fila de títulos o vacía
      piezas.push({ nombre: nombre, largo: nums[0] * U(), ancho: nums[1] * U(), cantidad: nums[2] ? Math.round(nums[2]) : 1 });
    });
    return piezas;
  }

  /* ---------- Generador de muebles ---------- */
  // Medidas en mm. e = espesor del tablero. Puertas y frentes con 3 mm de luz. Cantos visibles con tapacanto.
  var MUEBLES = {
    base: { nombre: 'Mueble base de cocina', alto: 720, ancho: 800, fondo: 560, puertas: 2, repisas: 1, cajones: 0 },
    aereo: { nombre: 'Mueble aéreo', alto: 700, ancho: 800, fondo: 320, puertas: 2, repisas: 1, cajones: 0 },
    cajonera: { nombre: 'Cajonera', alto: 720, ancho: 450, fondo: 500, puertas: 0, repisas: 0, cajones: 3 },
    closet: { nombre: 'Closet', alto: 2000, ancho: 900, fondo: 560, puertas: 2, repisas: 3, cajones: 0 },
    librero: { nombre: 'Librero', alto: 1800, ancho: 800, fondo: 300, puertas: 0, repisas: 4, cajones: 0 }
  };
  var LARGOS_CORREDERA = [250, 300, 350, 400, 450, 500];

  function generarMueble(tipo, g) {
    var e = g.espesor, A = g.alto, W = g.ancho, F = g.fondo, nombre = g.nombre;
    var p = [];
    var add = function (n, largo, ancho, cant, opts) {
      if (!(largo > 0 && ancho > 0 && cant > 0)) return;
      p.push(Object.assign({ nombre: nombre + ': ' + n, largo: Math.round(largo * 10) / 10, ancho: Math.round(ancho * 10) / 10, cantidad: cant, girar: true, cl: 1, ca: 0, tipo: 'pieza', mat: g.mat }, opts || {}));
    };
    var interior = W - 2 * e;
    add('lateral', A, F, 2);
    if (tipo === 'base') {
      add('base', interior, F, 1);
      add('amarre', interior, 100, 2);
    } else {
      add('base', interior, F, 1);
      add('techo', interior, F, 1);
    }
    if (tipo === 'closet') add('zócalo', interior, 80, 1, { cl: 1 });
    var altoUtil = A - (tipo === 'base' ? e : 2 * e) - (tipo === 'closet' ? 80 : 0);
    if (g.repisas > 0) add('repisa', interior - 2, F - 20, g.repisas, { tipo: 'repisa' });
    if (g.puertas > 0) {
      var ap = (W - 3 * g.puertas) / g.puertas, hp = A - 3 - (tipo === 'closet' ? 80 : 0);
      add('puerta', hp, ap, g.puertas, { tipo: 'puerta', girar: false, cl: 2, ca: 2 });
    }
    if (g.cajones > 0) {
      var hf = (A - 3 * (g.cajones + 1)) / g.cajones;
      add('frente de cajón', W - 3, hf, g.cajones, { tipo: 'cajon', girar: false, cl: 2, ca: 2 });
      // caja del cajón para correderas telescópicas de 12,7 mm por lado
      var lc = LARGOS_CORREDERA.filter(function (l) { return l <= F - 20; }).pop() || 250;
      var hc = Math.max(80, hf - 40), anchoCaja = interior - 2 * 12.7;
      add('lateral de cajón', lc, hc, 2 * g.cajones, { cl: 1 });
      add('frente y trasera de cajón', anchoCaja - 2 * e, hc, 2 * g.cajones, { cl: 1 });
      if (g.fondo_mat != null) add('fondo de cajón', anchoCaja, lc, g.cajones, { mat: g.fondo_mat, cl: 0 });
    }
    if (g.fondo_mat != null) add('fondo', W - 4, A - 4 - (tipo === 'closet' ? 80 : 0), 1, { mat: g.fondo_mat, cl: 0 });
    return altoUtil > 0 ? p : [];
  }

  function pintarGenerador() {
    var tipo = $('[data-gen-tipo]').value, d = MUEBLES[tipo];
    $('[data-gen-alto]').value = d.alto; $('[data-gen-ancho]').value = d.ancho; $('[data-gen-fondo]').value = d.fondo;
    $('[data-gen-puertas]').value = d.puertas; $('[data-gen-repisas]').value = d.repisas; $('[data-gen-cajones]').value = d.cajones;
    $('[data-gen-cajones-campo]').hidden = tipo !== 'cajonera';
    $('[data-gen-puertas-campo]').hidden = tipo === 'cajonera';
  }

  /* ---------- Paneles: generador de muebles y pegar desde Excel ---------- */
  var abrirPanel = function (cual) {
    ['generador', 'pegar'].forEach(function (k) { $('[data-panel-' + k + ']').hidden = k !== cual || !$('[data-panel-' + k + ']').hidden; });
  };
  $('[data-abrir-generador]').addEventListener('click', function () {
    abrirPanel('generador');
    var sel = $('[data-gen-mat]');
    sel.innerHTML = opcionesMaterial();
    if (!$('[data-panel-generador]').hidden) pintarGenerador();
  });
  $('[data-abrir-pegar]').addEventListener('click', function () { abrirPanel('pegar'); if (!$('[data-panel-pegar]').hidden) $('[data-pegar-texto]').focus(); });
  $('[data-gen-tipo]').addEventListener('change', pintarGenerador);
  $('[data-gen-agregar]').addEventListener('click', function () {
    var tipo = $('[data-gen-tipo]').value;
    var g = {
      nombre: ($('[data-gen-nombre]').value || '').trim() || MUEBLES[tipo].nombre,
      alto: num($('[data-gen-alto]').value), ancho: num($('[data-gen-ancho]').value), fondo: num($('[data-gen-fondo]').value),
      espesor: num($('[data-gen-espesor]').value) || 18,
      puertas: tipo === 'cajonera' ? 0 : Math.max(0, Math.round(num($('[data-gen-puertas]').value))),
      repisas: Math.max(0, Math.round(num($('[data-gen-repisas]').value))),
      cajones: tipo === 'cajonera' ? Math.max(1, Math.round(num($('[data-gen-cajones]').value))) : 0,
      mat: parseInt($('[data-gen-mat]').value || '0', 10) || 0,
      fondo_mat: null
    };
    if (!(g.alto > 100 && g.ancho > 100 && g.fondo > 100)) { $('[data-gen-aviso]').textContent = 'Revisa el alto, el ancho y el fondo del mueble (en mm).'; $('[data-gen-aviso]').hidden = false; return; }
    if ($('[data-gen-fondo-hdf]').checked) {
      var i = -1;
      estado.materiales.forEach(function (m, j) { if (i < 0 && /hdf|fondo|3 ?mm/i.test(m.nombre)) i = j; });
      if (i < 0) { estado.materiales.push(Object.assign(nuevoMaterial('HDF 3 mm (fondos)'))); i = estado.materiales.length - 1; }
      g.fondo_mat = i;
    }
    var nuevas = generarMueble(tipo, g);
    if (!nuevas.length) { $('[data-gen-aviso]').textContent = 'Con esas medidas no se puede armar el mueble. Revisa el alto y el espesor.'; $('[data-gen-aviso]').hidden = false; return; }
    $('[data-gen-aviso]').hidden = true;
    var vacias = estado.piezas.every(function (p) { return !p.largo && !p.ancho; });
    if (estado.ejemplo) { estado.piezas = []; estado.ejemplo = false; }
    estado.piezas = (vacias ? [] : estado.piezas).concat(nuevas);
    if (estado.unidad !== 'mm') estado.unidad = 'mm';
    guardar(); pintarMateriales(); pintarPiezas();
    $('[data-panel-generador]').hidden = true;
    var lista = raiz.querySelectorAll('[data-piezas] .cc-pieza');
    var primera = lista[lista.length - nuevas.length];
    if (primera) primera.scrollIntoView({ behavior: 'smooth', block: 'start' });
    avisoPiezas(nuevas.length + ' piezas agregadas para "' + g.nombre + '". Revísalas y ajusta lo que necesites.');
    evento('generador', { tipo: tipo, piezas: nuevas.length });
  });
  $('[data-pegar-agregar]').addEventListener('click', function () {
    var nuevas = leerPegado($('[data-pegar-texto]').value);
    var av = $('[data-pegar-aviso]');
    if (!nuevas.length) { av.textContent = 'No encontramos piezas. Cada fila debe tener al menos el largo y el ancho; el nombre y la cantidad son opcionales.'; av.hidden = false; return; }
    av.hidden = true;
    var vacias = estado.piezas.every(function (p) { return !p.largo && !p.ancho; });
    if (estado.ejemplo) { estado.piezas = []; estado.ejemplo = false; }
    var mat = estado.piezas.length ? estado.piezas[estado.piezas.length - 1].mat : 0;
    estado.piezas = (vacias ? [] : estado.piezas).concat(nuevas.map(function (p) { return Object.assign(piezaVacia(), p, { mat: mat }); }));
    guardar(); pintarPiezas();
    $('[data-pegar-texto]').value = '';
    $('[data-panel-pegar]').hidden = true;
    avisoPiezas(nuevas.length + (nuevas.length === 1 ? ' pieza agregada' : ' piezas agregadas') + ' desde tu lista. Revisa el tipo, el tapacanto y la veta de cada una.');
    evento('excel', { accion: 'pegar', piezas: nuevas.length });
  });
  function avisoPiezas(t) {
    var el = $('[data-piezas-ok]');
    el.textContent = t; el.hidden = false;
    clearTimeout(avisoPiezas.t); avisoPiezas.t = setTimeout(function () { el.hidden = true; }, 6000);
  }

  /* ---------- Botones del resultado ---------- */
  $('[data-calcular]').addEventListener('click', function () { calcular(false); });
  $('[data-validacion-seguir]').addEventListener('click', function () { calcular(true); });
  $('[data-pdf]').addEventListener('click', function () { pdf(); evento('pdf'); });
  $('[data-etiquetas]').addEventListener('click', etiquetas);
  $('[data-excel]').addEventListener('click', excel);
  $('[data-dxf]').addEventListener('click', function () { dxf(); evento('dxf'); });
  $('[data-copiar]').addEventListener('click', function () {
    var url = enlace();
    var fallback = function () { window.prompt('Copia este enlace:', url); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { avisar('Enlace copiado. Quien lo abra verá este mismo plan.'); }, fallback);
      evento('compartir', { canal: 'enlace' });
    } else fallback();
  });
  $('[data-whatsapp]').addEventListener('click', function () {
    var c = ultimo && ultimo.c;
    var texto = 'Te comparto mi plan de corte' + (nombreProyecto() ? ' "' + nombreProyecto() + '"' : '') + ' (' + (c ? c.nuevos + (c.nuevos === 1 ? ' tablero' : ' tableros') + ', ' : '') + 'hecho en toolstore.cl): ' + enlace();
    window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener');
    evento('compartir', { canal: 'whatsapp' });
  });

  pintarTodo();
  if (desdeEnlace) { guardar(); calcular(true); }
})();
